(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-superior"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-barsup-uc]');
  if (!bar) return;

  var track = bar.querySelector('.barsup-uc__track');
  if (track) {
    var base = track.querySelector('.barsup-uc__grupo');
    var rellenando = false;

    function medir() {
      return base ? base.getBoundingClientRect().width : 0;
    }

    function rellenar() {
      if (!base || rellenando) return;
      rellenando = true;
      var w = medir();
      if (w > 0) {
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var necesarios = Math.ceil((vw + w) / w) + 1;
        if (necesarios < 2) necesarios = 2;
        var actuales = track.querySelectorAll('.barsup-uc__grupo').length;
        while (actuales < necesarios) {
          var copia = base.cloneNode(true);
          copia.setAttribute('aria-hidden', 'true');
          track.appendChild(copia);
          actuales++;
        }
        track.style.setProperty('--bs-shift', w + 'px', 'important');
      }
      rellenando = false;
    }

    rellenar();
    window.addEventListener('load', rellenar);
    window.addEventListener('resize', rellenar);
    setTimeout(rellenar, 300);
    setTimeout(rellenar, 900);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(rellenar);
    }
  }

  if (bar.getAttribute('data-fijar') !== '1') return;

  var wrap = bar.closest('.shopify-section') || bar;
  var espaciador = wrap.nextElementSibling;
  if (!espaciador || !espaciador.classList.contains('barsup-uc-espaciador')) {
    espaciador = document.createElement('div');
    espaciador.className = 'barsup-uc-espaciador';
    wrap.parentNode.insertBefore(espaciador, wrap.nextSibling);
  }

  function aplicar() {
    var h = bar.offsetHeight;
    espaciador.style.height = h + 'px';
    document.documentElement.style.setProperty('--barsup-uc-alto', h + 'px');
    var cabFija = document.querySelector('.cabecera-uc-fija');
    if (cabFija) {
      cabFija.style.setProperty('top', h + 'px', 'important');
    }
  }

  aplicar();
  window.addEventListener('resize', aplicar);
  window.addEventListener('load', aplicar);
  setTimeout(aplicar, 350);
  setTimeout(aplicar, 800);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beneficios"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-benef-uc]');
  if (!raiz) return;
  if (!raiz.classList.contains('benef-uc--animar')) return;
  if (!('IntersectionObserver' in window)) { raiz.classList.add('benef-uc--visible'); return; }
  var obs = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { raiz.classList.add('benef-uc--visible'); obs.disconnect(); }
    });
  }, { threshold: 0.15 });
  obs.observe(raiz);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busqueda"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-buscar-uc]');
  if (!raiz) return;

  var input = raiz.querySelector('[data-buscar-input]');
  var vistaDef = raiz.querySelector('[data-buscar-defecto]');
  var vistaRes = raiz.querySelector('[data-buscar-resultados]');
  var lista = raiz.querySelector('[data-buscar-lista]');
  var estado = raiz.querySelector('[data-buscar-estado]');
  var verTodos = raiz.querySelector('[data-buscar-vertodos]');
  var cierres = raiz.querySelectorAll('[data-buscar-cerrar]');
  var base = raiz.getAttribute('data-base') || '/search';
  var sugUrl = raiz.getAttribute('data-sugerir');
  var extra = (raiz.getAttribute('data-selector') || '').trim();
  var sinTxt = raiz.getAttribute('data-sin') || '';
  var form = raiz.querySelector('[data-buscar-form]');
  var bloqueRec = raiz.querySelector('[data-buscar-recientes]');
  var chipsRec = raiz.querySelector('[data-buscar-recientes-chips]');
  var btnBorrar = raiz.querySelector('[data-buscar-borrar]');
  var maxRec = parseInt(raiz.getAttribute('data-max-recientes') || '6', 10);
  var CLAVE_REC = 'buscar_uc_recientes_v1';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function leerRecientes() { try { var a = JSON.parse(localStorage.getItem(CLAVE_REC) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function guardar(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var arr = leerRecientes().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    arr = arr.slice(0, maxRec > 0 ? maxRec : 6);
    try { localStorage.setItem(CLAVE_REC, JSON.stringify(arr)); } catch (e) {}
  }
  function pintarRecientes() {
    if (!bloqueRec || !chipsRec) return;
    var arr = leerRecientes();
    if (!arr.length) { bloqueRec.hidden = true; chipsRec.innerHTML = ''; return; }
    chipsRec.innerHTML = arr.map(function (q) {
      var e = esc(q);
      return '<button type="button" class="buscar-uc__chip" data-reciente="' + e + '">' + e + '</button>';
    }).join('');
    bloqueRec.hidden = false;
  }

  function abrir() {
    raiz.classList.add('uc-activo');
    document.body.style.overflow = 'hidden';
    pintarRecientes();
    setTimeout(function () { if (input) input.focus(); }, 140);
  }
  function cerrar() {
    raiz.classList.remove('uc-activo');
    document.body.style.overflow = '';
  }

  var selectores = '[data-abrir-buscar]';
  if (extra) selectores += ', ' + extra;

  document.addEventListener('click', function (e) {
    var t = e.target.closest(selectores);
    if (t) { e.preventDefault(); abrir(); return; }
    var a = e.target.closest('a[href]');
    if (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        if (/\/search\/?$/.test(u.pathname) && !u.search) { e.preventDefault(); abrir(); }
      } catch (err) {}
    }
  });

  cierres.forEach(function (b) { b.addEventListener('click', cerrar); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

  function tarjeta(p) {
    var url = p.url || '#';
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    var imgHtml = img ? '<img src="' + img + '" alt="" loading="lazy">' : '';
    var marca = p.vendor ? '<span class="buscar-uc__res-marca">' + p.vendor + '</span>' : '';
    return '<a class="buscar-uc__res" href="' + url + '"><span class="buscar-uc__res-img">' + imgHtml + '</span><span class="buscar-uc__res-info"><span class="buscar-uc__res-titulo">' + (p.title || '') + '</span>' + marca + '</span></a>';
  }

  var temporizador;
  function buscar(q) {
    if (!sugUrl) return;
    var url = sugUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        if (verTodos) verTodos.href = base + '?q=' + encodeURIComponent(q);
        if (!prods.length) {
          lista.innerHTML = '';
          estado.textContent = sinTxt;
          estado.hidden = false;
          return;
        }
        estado.hidden = true;
        lista.innerHTML = prods.map(tarjeta).join('');
      })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(temporizador);
      if (q.length < 2) {
        vistaRes.hidden = true;
        vistaDef.hidden = false;
        return;
      }
      vistaDef.hidden = true;
      vistaRes.hidden = false;
      estado.hidden = true;
      temporizador = setTimeout(function () { buscar(q); }, 220);
    });
  }

  if (form) { form.addEventListener('submit', function () { guardar(input ? input.value : ''); }); }
  if (verTodos) { verTodos.addEventListener('click', function () { guardar(input ? input.value : ''); }); }
  if (lista) { lista.addEventListener('click', function (e) { if (e.target.closest('a')) guardar(input ? input.value : ''); }); }
  if (vistaDef) {
    vistaDef.addEventListener('click', function (e) {
      var a = e.target.closest('a.buscar-uc__chip');
      if (a) guardar(a.textContent);
    });
  }
  if (chipsRec) {
    chipsRec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-reciente]');
      if (!b) return;
      var q = b.getAttribute('data-reciente');
      guardar(q);
      if (input) {
        input.value = q;
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
  if (btnBorrar) {
    btnBorrar.addEventListener('click', function () {
      try { localStorage.removeItem(CLAVE_REC); } catch (e) {}
      pintarRecientes();
    });
  }

  pintarRecientes();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-lateral-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-carrito-uc]');
  if (!raiz) return;

  function decodificar(texto) {
    var auxiliar = document.createElement('textarea');
    auxiliar.innerHTML = texto;
    return auxiliar.value;
  }

  function atributo(nombre, porDefecto) {
    var v = raiz.getAttribute(nombre);
    return v === null || v === '' ? (porDefecto || '') : decodificar(v);
  }

  var formato = atributo('data-money-format', '${{amount}}');
  var sugMaximo = parseInt(raiz.getAttribute('data-sug-maximo'), 10) || 2;
  var sugRespaldo = raiz.getAttribute('data-sug-respaldo') === '1';
  var CLAVE = 'uc_recientes';

  var promoActiva = raiz.getAttribute('data-promo-activa') === '1';
  var promoMinimo = parseInt(raiz.getAttribute('data-promo-minimo'), 10) || 2;
  var promoMonto = parseInt(raiz.getAttribute('data-promo-monto'), 10) || 0;
  var promoColeccion = atributo('data-promo-coleccion').trim();
  var promoTotal = parseInt(raiz.getAttribute('data-promo-total'), 10) || 0;
  var raizUrl = atributo('data-raiz-url', '/');
  if (raizUrl.charAt(raizUrl.length - 1) !== '/') raizUrl = raizUrl + '/';

  var idsPromo = {};
  var idsCargados = false;
  var idsPendientes = false;
  var ultimoCarrito = null;

  (function cargarIdsIniciales() {
    var crudo = atributo('data-promo-ids').trim();
    if (crudo) {
      crudo.split(',').forEach(function (id) {
        var limpio = id.trim();
        if (limpio) idsPromo[limpio] = true;
      });
    }
    if (!promoColeccion) {
      idsCargados = true;
      return;
    }
    idsCargados = Object.keys(idsPromo).length > 0 && promoTotal <= Object.keys(idsPromo).length;
  })();
  var promoFalta = atributo('data-promo-falta');
  var promoListo = atributo('data-promo-listo');
  var promoEtiqueta = atributo('data-promo-etiqueta');
  var promoSingular = atributo('data-promo-singular', 'par');
  var promoPlural = atributo('data-promo-plural', 'pares');

  var contador = raiz.querySelector('[data-uc-contador]');
  var items = raiz.querySelector('[data-uc-items]');
  var vacio = raiz.querySelector('[data-uc-vacio]');
  var pie = raiz.querySelector('[data-uc-pie]');
  var subtotal = raiz.querySelector('[data-uc-subtotal]');
  var subtotalAntes = raiz.querySelector('[data-uc-subtotal-antes]');
  var ahorroCaja = raiz.querySelector('[data-uc-ahorro]');
  var ahorroEtiqueta = raiz.querySelector('[data-uc-ahorro-etiqueta]');
  var ahorroMonto = raiz.querySelector('[data-uc-ahorro-monto]');
  var promoCaja = raiz.querySelector('[data-uc-promo]');
  var promoTexto = raiz.querySelector('[data-uc-promo-texto]');
  var sugCaja = raiz.querySelector('[data-uc-sugeridos]');
  var sugLista = raiz.querySelector('[data-uc-sug-lista]');
  var sugDeColeccion = !!(sugLista && sugLista.getAttribute('data-origen') === 'coleccion');
  var promoLinea = { key: null, monto: 0 };

  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function conAncho(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function dinero(centavos) {
    var num = Number(centavos);
    function sep(n, p, miles, dec) {
      p = p == null ? 2 : p; miles = miles || ','; dec = dec || '.';
      if (isNaN(n)) return '0';
      n = (n / 100).toFixed(p);
      var partes = n.split('.');
      var ent = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
      return ent + (partes[1] ? dec + partes[1] : '');
    }
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    var m = formato.match(ph);
    if (!m) return formato;
    var val;
    switch (m[1]) {
      case 'amount': val = sep(num, 2); break;
      case 'amount_no_decimals': val = sep(num, 0); break;
      case 'amount_with_comma_separator': val = sep(num, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = sep(num, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = sep(num, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = sep(num, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': val = sep(num, 0, ' ', '.'); break;
      default: val = sep(num, 2);
    }
    return formato.replace(ph, val);
  }

  function abrir() { raiz.classList.add('uc-abierto'); document.body.style.overflow = 'hidden'; }
  function cerrar() { raiz.classList.remove('uc-abierto'); document.body.style.overflow = ''; }

  function destinoCarrito() {
    return document.querySelector('.cabecera-uc__icono-btn--carrito') ||
           document.querySelector('[data-uc-abrir]') ||
           document.querySelector('a[href$="/cart"]');
  }

  function imagenDeForm(form) {
    var cont = form.closest('[class*="product"], article, .card, .grid__item, li');
    var img = cont ? cont.querySelector('img') : null;
    if (img) return img;
    return document.querySelector('[data-prod-principal], .product__media img, [class*="product"] img');
  }

  function volarAlCarrito(img) {
    return new Promise(function (resolve) {
      var destino = destinoCarrito();
      if (!img || !destino) { resolve(); return; }
      var o = img.getBoundingClientRect();
      var d = destino.getBoundingClientRect();
      if (o.width === 0 || o.height === 0) { resolve(); return; }
      var clon = document.createElement('img');
      clon.src = img.currentSrc || img.src;
      clon.style.cssText = 'position:fixed;z-index:10200;left:' + o.left + 'px;top:' + o.top + 'px;width:' + o.width + 'px;height:' + o.height + 'px;object-fit:cover;border-radius:12px;pointer-events:none;box-shadow:0 12px 30px rgba(0,0,0,0.25);transition:transform 0.72s cubic-bezier(0.5,-0.2,0.4,1),opacity 0.72s ease;opacity:0.96;';
      document.body.appendChild(clon);
      var dx = (d.left + d.width / 2) - (o.left + o.width / 2);
      var dy = (d.top + d.height / 2) - (o.top + o.height / 2);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clon.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
          clon.style.opacity = '0.2';
        });
      });
      setTimeout(function () {
        destino.style.transition = 'transform 0.2s ease';
        destino.style.transform = 'scale(1.28)';
        setTimeout(function () { destino.style.transform = ''; }, 220);
      }, 660);
      setTimeout(function () {
        if (clon.parentNode) clon.parentNode.removeChild(clon);
        resolve();
      }, 740);
    });
  }

  function claveCache() {
    return 'uc_promo_ids_' + promoColeccion;
  }

  function guardarCache(lista) {
    try { window.sessionStorage.setItem(claveCache(), JSON.stringify(lista)); } catch (e) {}
  }

  function leerCache() {
    try { return JSON.parse(window.sessionStorage.getItem(claveCache())) || null; } catch (e) { return null; }
  }

  function aplicarLista(lista) {
    (lista || []).forEach(function (id) { idsPromo[String(id)] = true; });
    idsCargados = true;
  }

  function completarIds() {
    if (idsCargados || idsPendientes || !promoColeccion) return;
    var cache = leerCache();
    if (cache) {
      aplicarLista(cache);
      if (ultimoCarrito) pintar(ultimoCarrito);
      return;
    }
    idsPendientes = true;
    fetch(raizUrl + 'collections/' + encodeURIComponent(promoColeccion) + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var lista = (datos.products || []).map(function (p) { return p.id; });
        guardarCache(lista);
        aplicarLista(lista);
        idsPendientes = false;
        if (ultimoCarrito) pintar(ultimoCarrito);
      })
      .catch(function () {
        idsPendientes = false;
        idsCargados = true;
        if (ultimoCarrito) pintar(ultimoCarrito);
      });
  }

  function elegible(item) {
    if (!promoColeccion) return true;
    return idsPromo[String(item.product_id)] === true;
  }

  function unidadesElegibles(cart) {
    return (cart.items || []).reduce(function (suma, it) {
      return elegible(it) ? suma + it.quantity : suma;
    }, 0);
  }

  function lineaMasBarata(cart) {
    var elegida = null;
    var respaldo = null;
    (cart.items || []).forEach(function (it) {
      if (!elegible(it)) return;
      if (!respaldo || it.final_line_price > respaldo.final_line_price) respaldo = it;
      if (it.final_line_price < promoMonto) return;
      if (!elegida || it.final_price < elegida.final_price) elegida = it;
    });
    return elegida || respaldo;
  }

  function conMonto(texto, monto, faltan) {
    return String(texto)
      .replace(/\{monto\}/g, dinero(monto))
      .replace(/\{faltan\}/g, faltan)
      .replace(/\{unidad\}/g, faltan === 1 ? promoSingular : promoPlural);
  }

  function calcularPromo(cart) {
    var estado = { aplica: false, monto: 0, faltan: 0, key: null };
    if (!promoActiva || promoMonto <= 0 || !cart.items || cart.items.length === 0) return estado;
    if (promoColeccion && !idsCargados) return estado;
    var unidades = unidadesElegibles(cart);
    if (unidades === 0) return estado;
    if (unidades >= promoMinimo) {
      var linea = lineaMasBarata(cart);
      estado.aplica = true;
      estado.monto = promoMonto;
      estado.key = linea ? linea.key : null;
    } else {
      estado.faltan = promoMinimo - unidades;
    }
    return estado;
  }

  function descuentoRealDe(item) {
    var lista = item.line_level_discount_allocations || item.discounts || [];
    var suma = 0;
    lista.forEach(function (d) {
      suma += (d.amount != null ? d.amount : 0);
    });
    if (suma === 0 && item.original_line_price != null && item.final_line_price != null) {
      suma = Math.max(0, item.original_line_price - item.final_line_price);
    }
    return suma;
  }

  function vistaItem(item) {
    var variante = (item.variant_title && item.variant_title !== '') ? '<span class="carrito-uc__item-var">' + esc(item.variant_title) + '</span>' : '';
    var img = item.image ? '<img src="' + conAncho(item.image, 160) + '" alt="">' : '';
    var real = descuentoRealDe(item);
    var esPromo = !real && promoLinea.key && item.key === promoLinea.key && promoLinea.monto > 0;
    var chip = '';
    var precios = '<span class="carrito-uc__item-precio">' + dinero(item.final_line_price) + '</span>';

    if (real > 0) {
      chip = '<span class="carrito-uc__item-chip">-' + dinero(real) + '</span>';
      precios = '<span class="carrito-uc__item-antes">' + dinero(item.original_line_price) + '</span>' +
                '<span class="carrito-uc__item-precio carrito-uc__item-precio--promo">' + dinero(item.final_line_price) + '</span>';
    } else if (esPromo) {
      var nuevo = Math.max(0, item.final_line_price - promoLinea.monto);
      chip = '<span class="carrito-uc__item-chip">-' + dinero(promoLinea.monto) + '</span>';
      precios = '<span class="carrito-uc__item-antes">' + dinero(item.final_line_price) + '</span>' +
                '<span class="carrito-uc__item-precio carrito-uc__item-precio--promo">' + dinero(nuevo) + '</span>';
    }

    return '<li class="carrito-uc__item' + ((esPromo || real > 0) ? ' carrito-uc__item--promo' : '') + '" data-uc-key="' + item.key + '">' +
      '<a class="carrito-uc__item-img" href="' + item.url + '">' + img + '</a>' +
      '<div class="carrito-uc__item-info">' +
        '<a class="carrito-uc__item-titulo" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
        variante + chip +
        '<div class="carrito-uc__item-fila">' +
          '<div class="carrito-uc__stepper">' +
            '<button type="button" data-uc-key="' + item.key + '" data-uc-accion="menos" aria-label="Quitar uno"><svg class="carrito-uc__ico"><use href="#cuico-menos"></use></svg></button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-uc-key="' + item.key + '" data-uc-accion="mas" aria-label="A&ntilde;adir uno"><svg class="carrito-uc__ico"><use href="#cuico-mas"></use></svg></button>' +
          '</div>' +
          '<span class="carrito-uc__item-precios">' + precios + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="carrito-uc__item-quitar" data-uc-key="' + item.key + '" data-uc-accion="quitar" aria-label="Eliminar"><svg class="carrito-uc__ico"><use href="#cuico-basura"></use></svg></button>' +
    '</li>';
  }

  function pintarTotales(cart, promo) {
    var real = cart.total_discount || 0;
    var base = (cart.items || []).reduce(function (suma, it) {
      return suma + (it.original_line_price != null ? it.original_line_price : it.final_line_price);
    }, 0);
    if (!base) base = cart.items_subtotal_price || cart.total_price || 0;

    var descuento = real > 0 ? real : promo.monto;
    var total = Math.max(0, base - descuento);

    if (subtotal) subtotal.textContent = dinero(total);
    if (subtotalAntes) {
      if (descuento > 0) {
        subtotalAntes.textContent = dinero(base);
        subtotalAntes.hidden = false;
      } else {
        subtotalAntes.hidden = true;
      }
    }
    if (ahorroCaja) {
      if (descuento > 0) {
        if (ahorroEtiqueta) ahorroEtiqueta.textContent = promoEtiqueta;
        if (ahorroMonto) ahorroMonto.textContent = '- ' + dinero(descuento);
        ahorroCaja.hidden = false;
      } else {
        ahorroCaja.hidden = true;
      }
    }
  }

  function pintarPromo(promo, montoReal) {
    if (!promoCaja || !promoTexto) return;
    if (!promoActiva || promoMonto <= 0) { promoCaja.hidden = true; return; }
    if (montoReal > 0) {
      promoTexto.textContent = conMonto(promoListo, montoReal, 0);
      promoCaja.classList.add('uc-promo-listo');
      promoCaja.hidden = false;
      return;
    }
    if (promo.aplica) {
      promoTexto.textContent = conMonto(promoListo, promoMonto, 0);
      promoCaja.classList.add('uc-promo-listo');
      promoCaja.hidden = false;
    } else if (promo.faltan > 0) {
      promoTexto.textContent = conMonto(promoFalta, promoMonto, promo.faltan);
      promoCaja.classList.remove('uc-promo-listo');
      promoCaja.hidden = false;
    } else {
      promoCaja.hidden = true;
    }
  }

  function normalizarTexto(str) {
    return String(str || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function ocultarBotonesDuplicadosCOD() {
    if (!raiz) return;
    var propio = raiz.querySelector('[data-uc-cod]');
    if (!propio) return;

    var candidatos = raiz.querySelectorAll('button, a, [role="button"]');
    candidatos.forEach(function (el) {
      if (el === propio) return;
      if (el.closest('[data-uc-cupon]')) return;
      var txt = normalizarTexto(el.textContent);
      var esCod = txt.indexOf('PAGAR CONTRA ENTREGA') > -1 || txt.indexOf('CONTRA ENTREGA') > -1;
      if (!esCod) return;

      var contenedor = el.parentElement;
      if (contenedor && contenedor !== pie && contenedor.childElementCount === 1) {
        contenedor.hidden = true;
        contenedor.style.display = 'none';
      }
      el.hidden = true;
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    });
  }

  function vigilarDuplicadosCOD() {
    if (!raiz || raiz.getAttribute('data-uc-cod-observer') === '1') return;
    raiz.setAttribute('data-uc-cod-observer', '1');
    var obs = new MutationObserver(function () {
      ocultarBotonesDuplicadosCOD();
    });
    obs.observe(raiz, { childList: true, subtree: true });
    ocultarBotonesDuplicadosCOD();
  }

  function pintar(cart) {
    ultimoCarrito = cart;
    if (promoColeccion && !idsCargados) completarIds();

    var montoReal = cart.total_discount || 0;
    var promo = montoReal > 0
      ? { aplica: false, monto: 0, faltan: 0, key: null }
      : calcularPromo(cart);
    promoLinea = { key: promo.key, monto: promo.monto };

    if (contador) contador.textContent = cart.item_count;

    if (cart.item_count === 0) {
      if (items) items.innerHTML = '';
      if (vacio) vacio.hidden = false;
      if (pie) pie.hidden = true;
      if (promoCaja) promoCaja.hidden = true;
    } else {
      if (vacio) vacio.hidden = true;
      if (pie) pie.hidden = false;
      if (items) items.innerHTML = cart.items.map(vistaItem).join('');
      pintarTotales(cart, promo);
      pintarPromo(promo, montoReal);
    }

    ocultarBotonesDuplicadosCOD();
    pintarSugeridos(cart);
    if (cuponActivo) mostrarResumen(cart);
  }

  function obtenerCarrito() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { pintar(cart); return cart; });
  }

  function cambiar(key, cantidad) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: cantidad })
    }).then(function (r) { return r.json(); }).then(function (cart) { pintar(cart); return cart; });
  }

  function agregar(id, cantidad, origen) {
    var cuerpo = { id: id, quantity: cantidad || 1 };
    if (origen) cuerpo.properties = { _origen: origen };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) { return r.json(); }).then(function () { return obtenerCarrito(); });
  }

  function leerRecientes() {
    try { return JSON.parse(window.localStorage.getItem(CLAVE)) || []; } catch (e) { return []; }
  }
  function guardarReciente(p) {
    try {
      var lista = leerRecientes().filter(function (x) { return x.handle !== p.handle; });
      lista.unshift(p);
      lista = lista.slice(0, 12);
      window.localStorage.setItem(CLAVE, JSON.stringify(lista));
    } catch (e) {}
  }

  function filaSugerida(p) {
    var img = p.image ? '<img src="' + conAncho(p.image, 160) + '" alt="" loading="lazy" width="56" height="56">' : '';
    var accion;
    if (p.multi !== false) {
      accion = '<a class="carrito-uc__sug-add" href="' + esc(p.url) + '" aria-label="' + esc(atributo('data-elegir-texto', 'Elegir talla')) + '"><svg class="carrito-uc__ico" aria-hidden="true"><use href="#cuico-cder"></use></svg></a>';
    } else {
      accion = '<button type="button" class="carrito-uc__sug-add" data-uc-quickadd data-uc-vid="' + esc(p.vid) + '" aria-label="' + esc(atributo('data-add-texto', 'Anadir')) + '"><svg class="carrito-uc__ico" aria-hidden="true"><use href="#cuico-mas"></use></svg></button>';
    }
    return '<li class="carrito-uc__sug-fila" data-uc-sug-fila data-handle="' + esc(p.handle) + '">' +
      '<a class="carrito-uc__sug-img" href="' + esc(p.url) + '">' + img + '</a>' +
      '<div class="carrito-uc__sug-info">' +
        '<a class="carrito-uc__sug-nombre" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="carrito-uc__sug-precio">' + dinero(p.price) + '</span>' +
      '</div>' + accion +
    '</li>';
  }

  function pintarSugeridos(cart) {
    if (!sugCaja || !sugLista) return;
    var enCarrito = {};
    ((cart && cart.items) || []).forEach(function (it) { enCarrito[it.handle] = true; });

    if (!sugDeColeccion) {
      if (!sugRespaldo) { sugCaja.hidden = true; return; }
      var actual = handleActual();
      var lista = leerRecientes().filter(function (p) {
        return p.handle !== actual && !enCarrito[p.handle] && p.available;
      }).slice(0, sugMaximo);
      sugLista.innerHTML = lista.map(filaSugerida).join('');
      sugCaja.hidden = lista.length === 0;
      return;
    }

    var mostradas = 0;
    sugLista.querySelectorAll('[data-uc-sug-fila]').forEach(function (fila) {
      var ver = !enCarrito[fila.getAttribute('data-handle')] && mostradas < sugMaximo;
      fila.hidden = !ver;
      if (ver) mostradas++;
    });
    sugCaja.hidden = mostradas === 0;
  }

  function handleActual() {
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }

  function registrarVista() {
    var handle = handleActual();
    if (!handle) return;
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var disp = (p.variants || []).filter(function (v) { return v.available; });
        var elegida = disp[0] || p.variants[0] || {};
        guardarReciente({
          handle: p.handle,
          title: p.title,
          url: '/products/' + p.handle,
          image: p.featured_image || (p.images && p.images[0]) || '',
          price: p.price,
          vid: elegida.id,
          available: disp.length > 0,
          multi: (p.variants || []).length > 1
        });
        pintarSugeridos(ultimoCarrito);
      }).catch(function () {});
  }

  function esDisparador(el) {
    if (!el || !el.closest) return null;
    return el.closest('.cabecera-uc__icono-btn--carrito, [data-uc-abrir], a[href$="/cart"], a[href*="/cart?"], a[href$="/cart/"]');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var disp = esDisparador(e.target);
    if (disp && !disp.closest('[data-carrito-uc]')) {
      e.preventDefault();
      e.stopPropagation();
      obtenerCarrito().then(abrir);
      return;
    }
    if (e.target.closest('[data-uc-cerrar]')) { cerrar(); return; }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var datos = new FormData(form);
    var boton = form.querySelector('[type="submit"]');
    if (boton) boton.classList.add('uc-cargando');
    var origen = imagenDeForm(form);
    var animacion = volarAlCarrito(origen);
    var peticion = fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: datos })
      .then(function (r) { return r.json(); })
      .then(function () { return obtenerCarrito(); });
    Promise.all([animacion, peticion])
      .then(function () { abrir(); if (boton) boton.classList.remove('uc-cargando'); })
      .catch(function () { if (boton) boton.classList.remove('uc-cargando'); });
  }, true);

  raiz.addEventListener('click', function (e) {
    var accionBtn = e.target.closest('[data-uc-accion]');
    if (accionBtn) {
      var key = accionBtn.getAttribute('data-uc-key');
      var li = accionBtn.closest('.carrito-uc__item');
      var actual = li ? parseInt(li.querySelector('.carrito-uc__stepper span').textContent, 10) : 1;
      var accion = accionBtn.getAttribute('data-uc-accion');
      if (accion === 'mas') cambiar(key, actual + 1);
      else if (accion === 'menos') cambiar(key, Math.max(0, actual - 1));
      else if (accion === 'quitar') cambiar(key, 0);
      return;
    }
    var quick = e.target.closest('[data-uc-quickadd]');
    if (quick) {
      var vid = quick.getAttribute('data-uc-vid');
      if (!vid) return;
      quick.classList.add('uc-cargando');
      agregar(vid, 1, 'carrito-sugeridos').then(function () { quick.classList.remove('uc-cargando'); }).catch(function () { quick.classList.remove('uc-cargando'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && raiz.classList.contains('uc-abierto')) cerrar();
  });
  window.addEventListener('pageshow', function () { obtenerCarrito(); });

  var cupon = raiz.querySelector('[data-uc-cupon]');
  var cuponActivo = '';
  var pagar = raiz.querySelector('[data-uc-pagar]');

  function actualizarPagar() {
    if (!pagar) return;
    pagar.href = cuponActivo ? ('/discount/' + encodeURIComponent(cuponActivo) + '?redirect=/checkout') : '/checkout';
  }

  function mostrarResumen(cart) {
    if (!cupon) return;
    var resumen = cupon.querySelector('[data-uc-resumen]');
    if (!resumen) return;
    var desc = cart.total_discount || 0;
    if (cuponActivo && desc > 0) {
      cupon.querySelector('[data-uc-r-sub]').textContent = dinero(cart.items_subtotal_price || cart.total_price + desc);
      cupon.querySelector('[data-uc-r-desc]').textContent = '- ' + dinero(desc);
      cupon.querySelector('[data-uc-r-total]').textContent = dinero(cart.total_price);
      resumen.hidden = false;
    } else {
      resumen.hidden = true;
    }
  }

  if (cupon) {
    var toggle = cupon.querySelector('[data-uc-cupon-toggle]');
    var panelCupon = cupon.querySelector('[data-uc-cupon-panel]');
    var input = cupon.querySelector('[data-uc-cupon-input]');
    var aplicarBtn = cupon.querySelector('[data-uc-cupon-aplicar]');
    var msg = cupon.querySelector('[data-uc-cupon-msg]');
    var chip = cupon.querySelector('[data-uc-cupon-chip]');
    var chipCodigo = cupon.querySelector('[data-uc-cupon-codigo]');
    var quitarBtn = cupon.querySelector('[data-uc-cupon-quitar]');

    var T_OK = atributo('data-cupon-ok', 'Cupon aplicado');
    var T_INFO = atributo('data-cupon-info', 'Cupon anadido');
    var T_ERROR = atributo('data-cupon-error', 'Escribe un codigo valido');

    function decirMsg(texto, tipo) {
      if (!msg) return;
      msg.textContent = texto;
      msg.className = 'carrito-uc__cupon-msg' + (tipo ? ' uc-' + tipo : '');
      msg.hidden = !texto;
    }

    if (toggle) toggle.addEventListener('click', function () {
      var abierto = cupon.classList.toggle('uc-cupon-abierto');
      if (panelCupon) panelCupon.hidden = !abierto;
      if (abierto && input) input.focus();
    });

    function aplicarCupon() {
      var codigo = (input ? input.value : '').trim();
      if (!codigo) { decirMsg(T_ERROR, 'error'); return; }
      if (aplicarBtn) aplicarBtn.classList.add('uc-cargando');
      decirMsg('', '');
      fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cuponActivo = codigo;
          actualizarPagar();
          if (chipCodigo) chipCodigo.textContent = codigo;
          if (chip) chip.hidden = false;
          if (cart.total_discount && cart.total_discount > 0) {
            decirMsg(T_OK, 'ok');
          } else {
            decirMsg(T_INFO, 'info');
          }
          pintar(cart);
          mostrarResumen(cart);
          if (aplicarBtn) aplicarBtn.classList.remove('uc-cargando');
        })
        .catch(function () {
          if (aplicarBtn) aplicarBtn.classList.remove('uc-cargando');
          decirMsg(T_ERROR, 'error');
        });
    }

    if (aplicarBtn) aplicarBtn.addEventListener('click', aplicarCupon);
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); aplicarCupon(); }
    });

    if (quitarBtn) quitarBtn.addEventListener('click', function () {
      cuponActivo = '';
      actualizarPagar();
      if (chip) chip.hidden = true;
      if (input) input.value = '';
      decirMsg('', '');
      var resumen = cupon.querySelector('[data-uc-resumen]');
      if (resumen) resumen.hidden = true;
      fetch('/discount/clear', { credentials: 'same-origin' }).catch(function () {});
      obtenerCarrito();
    });
  }

  registrarVista();
  vigilarDuplicadosCOD();
  obtenerCarrito();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(raiz) {
    var pista = raiz.querySelector('[data-col-pista]');
    var thumb = raiz.querySelector('[data-col-thumb]');
    var prev = raiz.querySelector('[data-col-prev]');
    var next = raiz.querySelector('[data-col-next]');
    if (!pista) return;

    function maxScroll() {
      return pista.scrollWidth - pista.clientWidth;
    }

    function actualizar() {
      var ancho = pista.scrollWidth;
      if (ancho <= 0) return;
      var visible = (pista.clientWidth / ancho) * 100;
      if (visible > 100) visible = 100;
      if (visible < 8) visible = 8;
      var rango = 100 - visible;
      var fin = maxScroll();
      var avance = fin > 0 ? (pista.scrollLeft / fin) : 0;
      var pos = avance * rango;
      if (thumb) {
        thumb.style.setProperty('--cu-thumb-ancho', visible + '%');
        thumb.style.setProperty('--cu-thumb-left', pos + '%');
      }
      if (prev) prev.classList.toggle('col-inactiva', pista.scrollLeft <= 2);
      if (next) next.classList.toggle('col-inactiva', pista.scrollLeft >= fin - 2);
    }

    function desplazar(dir) {
      var card = pista.querySelector('.coleccion-uc__card');
      var paso = card ? (card.offsetWidth + 16) : pista.clientWidth * 0.8;
      var cantidad = Math.max(1, Math.floor(pista.clientWidth / paso)) * paso;
      pista.scrollBy({ left: dir * cantidad, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { desplazar(-1); });
    if (next) next.addEventListener('click', function () { desplazar(1); });

    pista.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizar);
    });
    window.addEventListener('resize', actualizar);
    window.addEventListener('load', actualizar);
    setTimeout(actualizar, 400);

    var progreso = raiz.querySelector('[data-col-progreso]');
    var scrubeando = false;

    function scrubA(clientX) {
      var r = progreso.getBoundingClientRect();
      if (r.width <= 0) return;
      var ratio = (clientX - r.left) / r.width;
      ratio = Math.max(0, Math.min(1, ratio));
      pista.scrollLeft = ratio * maxScroll();
      actualizar();
    }
    if (progreso) {
      progreso.addEventListener('pointerdown', function (e) {
        scrubeando = true;
        try { progreso.setPointerCapture(e.pointerId); } catch (err) {}
        scrubA(e.clientX);
      });
      progreso.addEventListener('pointermove', function (e) {
        if (scrubeando) scrubA(e.clientX);
      });
      progreso.addEventListener('pointerup', function () { scrubeando = false; });
      progreso.addEventListener('pointercancel', function () { scrubeando = false; });
    }

    var arrastrando = false;
    var inicioX = 0;
    var inicioScroll = 0;
    var movido = false;

    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      arrastrando = true;
      movido = false;
      inicioX = e.clientX;
      inicioScroll = pista.scrollLeft;
      pista.classList.add('col-arrastrando');
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var dx = e.clientX - inicioX;
      if (Math.abs(dx) > 3) movido = true;
      pista.scrollLeft = inicioScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('col-arrastrando');
    });
    pista.addEventListener('click', function (e) {
      if (movido) {
        e.preventDefault();
        e.stopPropagation();
        movido = false;
      }
    }, true);

    var cards = raiz.querySelectorAll('[data-col-card]');
    cards.forEach(function (card) {
      card.addEventListener('touchstart', function () {
        card.classList.add('col-segunda');
      }, { passive: true });
      card.addEventListener('touchend', function () {
        setTimeout(function () { card.classList.remove('col-segunda'); }, 1200);
      });
    });

    actualizar();
  }

  var todos = document.querySelectorAll('[data-coleccion-uc]');
  todos.forEach(function (raiz) {
    if (raiz.getAttribute('data-col-listo')) return;
    raiz.setAttribute('data-col-listo', '1');
    iniciarCarrusel(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categorias-carrusel-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-categorias-uc]');
  if (!raiz) return;

  var pista = raiz.querySelector('[data-cat-pista]');
  var prev = raiz.querySelector('[data-cat-prev]');
  var next = raiz.querySelector('[data-cat-next]');
  if (!pista) return;

  function maxScroll() {
    return pista.scrollWidth - pista.clientWidth;
  }

  function actualizar() {
    var fin = maxScroll();
    if (prev) prev.classList.toggle('cat-inactiva', pista.scrollLeft <= 2);
    if (next) next.classList.toggle('cat-inactiva', pista.scrollLeft >= fin - 2);
  }

  function paso() {
    var card = pista.querySelector('.categorias-uc__card');
    var ancho = card ? (card.offsetWidth + 16) : pista.clientWidth * 0.8;
    var cantidad = Math.max(1, Math.floor(pista.clientWidth / ancho)) * ancho;
    return cantidad;
  }

  if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });

  pista.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); });
  window.addEventListener('resize', actualizar);
  window.addEventListener('load', actualizar);
  setTimeout(actualizar, 300);

  var arrastrando = false;
  var inicioX = 0;
  var inicioScroll = 0;
  var movido = false;

  pista.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    arrastrando = true;
    movido = false;
    inicioX = e.clientX;
    inicioScroll = pista.scrollLeft;
    pista.classList.add('cat-arrastrando');
  });
  window.addEventListener('pointermove', function (e) {
    if (!arrastrando) return;
    var dx = e.clientX - inicioX;
    if (Math.abs(dx) > 3) movido = true;
    pista.scrollLeft = inicioScroll - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!arrastrando) return;
    arrastrando = false;
    pista.classList.remove('cat-arrastrando');
  });
  pista.addEventListener('click', function (e) {
    if (movido) {
      e.preventDefault();
      e.stopPropagation();
      movido = false;
    }
  }, true);

  actualizar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chat-wha"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-wa-uc]');
  if (!raiz) return;

  var usaPanel = raiz.getAttribute('data-panel') === '1';
  var btn = raiz.querySelector('[data-wa-toggle]');
  var panel = raiz.querySelector('[data-wa-panel]');
  var cerrar = raiz.querySelector('[data-wa-cerrar]');
  var CLAVE = 'wa_uc_urban_v1';
  var dias = parseInt(raiz.getAttribute('data-dias') || '0', 10);

  function marcar() { try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) {} }
  function ocultoReciente() {
    try {
      var t = parseInt(localStorage.getItem(CLAVE) || '0', 10);
      if (!t || dias <= 0) return false;
      return (Date.now() - t) < dias * 86400000;
    } catch (e) { return false; }
  }
  function abrir() { raiz.classList.add('uc-abierto'); if (panel) panel.setAttribute('aria-hidden', 'false'); }
  function cerrarP() { raiz.classList.remove('uc-abierto'); if (panel) panel.setAttribute('aria-hidden', 'true'); marcar(); }

  if (usaPanel && btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (raiz.classList.contains('uc-abierto')) { cerrarP(); }
      else { abrir(); }
    });
    if (cerrar) cerrar.addEventListener('click', function (e) { e.stopPropagation(); cerrarP(); });
    document.addEventListener('click', function (e) {
      if (raiz.classList.contains('uc-abierto') && !raiz.contains(e.target)) cerrarP();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarP(); });

    if (raiz.getAttribute('data-auto') === '1' && !ocultoReciente()) {
      var retraso = parseInt(raiz.getAttribute('data-retraso') || '6', 10);
      setTimeout(function () { if (!raiz.classList.contains('uc-abierto')) abrir(); }, retraso * 1000);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuadricula-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('[data-cuadricula-uc]');
  if (!grids.length) return;

  function agregarDesde(btn) {
    var vid = btn.getAttribute('data-vid');
    if (!vid) return;
    var card = btn.closest('[data-prod-card]') || document.body;
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.style.display = 'none';
    f.innerHTML = '<input type="hidden" name="id" value="' + vid + '"><input type="hidden" name="quantity" value="1">';
    card.appendChild(f);
    f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 80);
  }

  function cerrarTallas(scope) {
    (scope || document).querySelectorAll('.tarjeta-uc.uc-tallas-abierto').forEach(function (c) {
      c.classList.remove('uc-tallas-abierto');
    });
  }
  function cerrarSidebar(grid) {
    var sb = grid.querySelector('[data-prod-sidebar]');
    var ov = grid.querySelector('[data-prod-overlay]');
    if (sb) { sb.classList.remove('uc-activo'); sb.setAttribute('aria-hidden', 'true'); }
    if (ov) ov.classList.remove('uc-activo');
    document.body.style.overflow = '';
  }

  grids.forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-prod-toggle]');
      if (toggle) {
        var card = toggle.closest('[data-prod-card]');
        if (!card) return;
        var abierto = card.classList.contains('uc-tallas-abierto');
        cerrarTallas(grid);
        if (!abierto) card.classList.add('uc-tallas-abierto');
        return;
      }
      var talla = e.target.closest('[data-prod-cerrar]');
      if (talla) {
        var addBtn = e.target.closest('[data-prod-add]');
        if (addBtn) agregarDesde(addBtn);
        var c = talla.closest('[data-prod-card]');
        if (c) setTimeout(function () { c.classList.remove('uc-tallas-abierto'); }, 180);
        return;
      }
      var addSolo = e.target.closest('[data-prod-add]');
      if (addSolo) {
        agregarDesde(addSolo);
        return;
      }
      var fdrop = e.target.closest('[data-prod-fdrop]');
      if (fdrop) {
        var cont = fdrop.closest('[data-prod-filtro]');
        if (cont) cont.classList.toggle('cuadricula-uc__grupo--abierto');
        return;
      }
      if (e.target.closest('[data-prod-filtros-abrir]')) {
        var sb = grid.querySelector('[data-prod-sidebar]');
        var ov = grid.querySelector('[data-prod-overlay]');
        if (sb) { sb.classList.add('uc-activo'); sb.setAttribute('aria-hidden', 'false'); }
        if (ov) ov.classList.add('uc-activo');
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-prod-filtros-cerrar]') || e.target.closest('[data-prod-overlay]')) {
        cerrarSidebar(grid);
        return;
      }
    });

    var sort = grid.querySelector('[data-prod-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }

    var form = grid.querySelector('[data-prod-filtros-form]');
    if (form) {
      form.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
        inp.addEventListener('change', function () { form.submit(); });
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-prod-card]')) cerrarTallas(document);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      cerrarTallas(document);
      grids.forEach(function (g) { cerrarSidebar(g); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futbol-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-futbol-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-fb-tab]');
  var paneles = raiz.querySelectorAll('[data-fb-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-fb-tab');
      tabs.forEach(function (t) { t.classList.remove('futbol-uc__tab--activo'); });
      tab.classList.add('futbol-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('futbol-uc__panel--activo', p.getAttribute('data-fb-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hombre-mujer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-genero-uc]');
  if (!raiz) return;
  raiz.querySelectorAll('.genero-uc__chip[data-href]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var url = chip.getAttribute('data-href');
      if (url && url !== '#') window.location.href = url;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-populares-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var track = raiz.querySelector('[data-pop-track]');
    if (!track) return;
    var prev = raiz.querySelector('[data-pop-prev]');
    var next = raiz.querySelector('[data-pop-next]');

    function paso() {
      var card = track.querySelector('.populares-uc__card');
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 16;
      return (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(track.clientWidth / (card.getBoundingClientRect().width + gap)));
    }

    function actualizarFlechas() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizarFlechas);
    }, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
  }

  document.querySelectorAll('[data-populares-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-pop-listo')) return;
    raiz.setAttribute('data-pop-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modo-deporte-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-pdep-uc]');
  if (!raiz) return;
  var rot = raiz.querySelector('[data-pdep-rot]');
  if (!rot) return;
  var span = rot.querySelector('.pdep-uc__rot-word');
  var crudas = (raiz.getAttribute('data-palabras') || '').split('||').filter(Boolean);
  if (crudas.length <= 1) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var i = 0;
  span.textContent = crudas[0];
  setInterval(function () {
    rot.classList.add('pdep-uc__rot--out');
    setTimeout(function () {
      i = (i + 1) % crudas.length;
      span.textContent = crudas[i];
      rot.classList.remove('pdep-uc__rot--out');
    }, 280);
  }, 2200);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notificacion-social-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-activo') !== '1') return;

    var datosEl = raiz.querySelector('[data-notif-productos]');
    if (!datosEl) return;
    var productos = [];
    try { productos = JSON.parse(datosEl.textContent); } catch (e) { return; }
    if (!productos.length) return;

    var KEY_CERRADO = 'notifuc_cerrado_en';
    function leer(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function guardar(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

    var frecuencia = parseFloat(raiz.getAttribute('data-frecuencia'));
    if (isNaN(frecuencia)) frecuencia = 6;
    var cerradoEn = parseInt(leer(KEY_CERRADO), 10);
    if (!isNaN(cerradoEn) && (Date.now() - cerradoEn) / 3600000 < frecuencia) return;

    var retraso = parseFloat(raiz.getAttribute('data-retraso'));
    if (isNaN(retraso)) retraso = 4;
    var duracion = parseFloat(raiz.getAttribute('data-duracion'));
    if (isNaN(duracion)) duracion = 5;
    var intervalo = parseFloat(raiz.getAttribute('data-intervalo'));
    if (isNaN(intervalo)) intervalo = 12;
    var maxDias = parseInt(raiz.getAttribute('data-max-dias'), 10) || 6;

    function lista(attr, fallback) {
      var raw = (raiz.getAttribute(attr) || '').split(/[\n,]+/).map(function (x) { return x.trim(); }).filter(Boolean);
      return raw.length ? raw : fallback;
    }
    var nombres = lista('data-nombres', ['Andrés', 'Laura', 'Santiago', 'Valentina', 'Juan', 'Mariana']);
    var ciudades = lista('data-ciudades', ['Medellín', 'Bogotá', 'Cali', 'Barranquilla']);
    var verbos = lista('data-verbos', ['compró', 'acaba de comprar']);
    var textoVerif = raiz.getAttribute('data-verificado') || 'Verificado';

    var imgEl = raiz.querySelector('[data-notif-img]');
    var personaEl = raiz.querySelector('[data-notif-persona]');
    var verboEl = raiz.querySelector('[data-notif-verbo]');
    var tituloEl = raiz.querySelector('[data-notif-titulo]');
    var tiempoEl = raiz.querySelector('[data-notif-tiempo]');
    var verifEl = raiz.querySelector('[data-notif-verif]');
    var enlaceEl = raiz.querySelector('[data-notif-enlace]');
    var ojoEl = raiz.querySelector('[data-notif-ojo]');
    var cerrarBtn = raiz.querySelector('[data-notif-cerrar]');

    if (verifEl) verifEl.textContent = textoVerif;

    function azar(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function tiempoTexto() {
      if (Math.random() < 0.45) {
        var min = Math.floor(Math.random() * 55) + 4;
        return 'hace ' + min + ' minutos';
      }
      if (Math.random() < 0.6) {
        var h = Math.floor(Math.random() * 23) + 1;
        return 'hace ' + h + (h === 1 ? ' hora' : ' horas');
      }
      var d = Math.floor(Math.random() * maxDias) + 1;
      return 'hace ' + d + (d === 1 ? ' día' : ' días');
    }

    var orden = productos.slice();
    for (var i = orden.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = orden[i]; orden[i] = orden[j]; orden[j] = tmp;
    }
    var puntero = 0;
    var visible = false;
    var timerOcultar = null;
    var timerSiguiente = null;

    function construir() {
      var p = orden[puntero % orden.length];
      puntero++;
      if (imgEl) { imgEl.src = p.img; imgEl.alt = p.titulo; }
      if (personaEl) personaEl.textContent = azar(nombres) + ' (' + azar(ciudades) + ')';
      if (verboEl) verboEl.textContent = azar(verbos);
      if (tituloEl) tituloEl.textContent = p.titulo;
      if (tiempoEl) tiempoEl.textContent = tiempoTexto();
      if (enlaceEl) enlaceEl.setAttribute('href', p.url);
      if (ojoEl) ojoEl.setAttribute('href', p.url);
    }

    function mostrar() {
      construir();
      raiz.classList.add('notif-uc--visible');
      visible = true;
      timerOcultar = setTimeout(ocultar, duracion * 1000);
    }
    function ocultar() {
      raiz.classList.remove('notif-uc--visible');
      visible = false;
      timerSiguiente = setTimeout(mostrar, intervalo * 1000);
    }

    if (cerrarBtn) {
      cerrarBtn.addEventListener('click', function (e) {
        e.preventDefault();
        raiz.classList.remove('notif-uc--visible');
        if (timerOcultar) clearTimeout(timerOcultar);
        if (timerSiguiente) clearTimeout(timerSiguiente);
        guardar(KEY_CERRADO, String(Date.now()));
      });
    }

    setTimeout(mostrar, Math.max(0, retraso) * 1000);
  }

  document.querySelectorAll('[data-notif-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-notif-listo')) return;
    raiz.setAttribute('data-notif-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagbusqueda"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-busqres-uc]');
  if (!raiz) return;

  var form = raiz.querySelector('[data-busqres-form]');
  if (form) {
    var sort = form.querySelector('[data-busqres-sort]');
    if (sort) sort.addEventListener('change', function () { form.submit(); });
    form.querySelectorAll('[data-busqres-auto]').forEach(function (c) {
      c.addEventListener('change', function () { form.submit(); });
    });
  }

  var abrir = raiz.querySelector('[data-prod-filtros-abrir]');
  var sidebar = raiz.querySelector('[data-prod-sidebar]');
  var overlay = raiz.querySelector('[data-prod-overlay]');
  function abrirF() { if (sidebar) sidebar.classList.add('uc-activo'); if (overlay) overlay.classList.add('uc-activo'); document.body.style.overflow = 'hidden'; }
  function cerrarF() { if (sidebar) sidebar.classList.remove('uc-activo'); if (overlay) overlay.classList.remove('uc-activo'); document.body.style.overflow = ''; }
  if (abrir) abrir.addEventListener('click', abrirF);
  if (overlay) overlay.addEventListener('click', cerrarF);
  raiz.querySelectorAll('[data-prod-filtros-cerrar]').forEach(function (b) { b.addEventListener('click', cerrarF); });

  function agregar(btn) {
    var card = btn.closest('[data-prod-card]');
    var vid = btn.getAttribute('data-vid');
    if (!card || !vid) return;
    var f = document.createElement('form');
    f.action = '/cart/add'; f.method = 'post'; f.style.display = 'none';
    var i = document.createElement('input'); i.type = 'hidden'; i.name = 'id'; i.value = vid; f.appendChild(i);
    card.appendChild(f);
    f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 1500);
  }

  raiz.addEventListener('click', function (e) {
    var drop = e.target.closest('[data-prod-fdrop]');
    if (drop) { var g = drop.closest('[data-prod-filtro]'); if (g) g.classList.toggle('busqres-uc__grupo--abierto'); return; }
    var tog = e.target.closest('[data-prod-toggle]');
    if (tog) { var c = tog.closest('[data-prod-card]'); if (c) c.classList.toggle('busqres-uc__card--tallas'); return; }
    var add = e.target.closest('[data-prod-add]');
    if (add) { e.preventDefault(); agregar(add); var cc = add.closest('[data-prod-card]'); if (cc) cc.classList.remove('busqres-uc__card--tallas'); return; }
    var card = e.target.closest('[data-prod-card]');
    if (!card) { raiz.querySelectorAll('.busqres-uc__card--tallas').forEach(function (x) { x.classList.remove('busqres-uc__card--tallas'); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-basquet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-basquet-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-bk-tab]');
  var paneles = raiz.querySelectorAll('[data-bk-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-bk-tab');
      tabs.forEach(function (t) { t.classList.remove('basquet-uc__tab--activo'); });
      tab.classList.add('basquet-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('basquet-uc__panel--activo', p.getAttribute('data-bk-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-gym"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-gym-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-gy-tab]');
  var paneles = raiz.querySelectorAll('[data-gy-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-gy-tab');
      tabs.forEach(function (t) { t.classList.remove('gym-uc__tab--activo'); });
      tab.classList.add('gym-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('gym-uc__panel--activo', p.getAttribute('data-gy-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-marcas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-marcas-uc]');
  if (!raiz) return;

  var pills = raiz.querySelector('[data-marcas-pills]');
  var buscar = raiz.querySelector('[data-marcas-buscar]');
  var vacio = raiz.querySelector('[data-marcas-vacio]');
  var grupos = raiz.querySelectorAll('[data-letra-grupo]');
  var items = raiz.querySelectorAll('[data-marca]');
  var destBloque = raiz.querySelector('[data-marcas-dest]');
  var destGrid = raiz.querySelector('[data-marcas-destacadas]');

  var catActiva = '';
  var consulta = '';

  function filtrar() {
    var visiblesTotales = 0;
    items.forEach(function (it) {
      var cat = it.getAttribute('data-categoria');
      var nom = it.getAttribute('data-nombre') || '';
      var okCat = catActiva === '' || cat === null || cat === catActiva;
      var okBuscar = consulta === '' || nom.indexOf(consulta) !== -1;
      var ver = okCat && okBuscar;
      it.style.display = ver ? '' : 'none';
      if (ver) visiblesTotales++;
    });
    grupos.forEach(function (g) {
      var visibles = g.querySelectorAll('[data-marca]:not([style*="display: none"])');
      g.style.display = visibles.length ? '' : 'none';
    });
    if (destBloque && destGrid) {
      var destVis = destGrid.querySelectorAll('[data-marca]:not([style*="display: none"])');
      destBloque.style.display = destVis.length ? '' : 'none';
    }
    if (vacio) vacio.hidden = visiblesTotales !== 0;
  }

  if (pills) {
    pills.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat]');
      if (!b) return;
      pills.querySelectorAll('.marcas-uc__pill').forEach(function (p) {
        p.classList.remove('marcas-uc__pill--activa');
      });
      b.classList.add('marcas-uc__pill--activa');
      catActiva = b.getAttribute('data-cat') || '';
      var titulo = raiz.querySelector('[data-marcas-titulo]');
      if (titulo) {
        if (catActiva === '') {
          titulo.textContent = titulo.getAttribute('data-default');
        } else {
          titulo.textContent = b.textContent.trim();
        }
      }
      filtrar();
    });
  }

  if (buscar) {
    buscar.addEventListener('input', function () {
      consulta = buscar.value.trim().toLowerCase();
      filtrar();
    });
  }

  raiz.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-letra-tog]');
    if (tog) {
      var g = tog.closest('[data-letra-grupo]');
      if (g) g.classList.toggle('marcas-uc__grupo--abierto');
      return;
    }
    var abc = e.target.closest('.marcas-uc__abc-letra[href]');
    if (abc) {
      var id = abc.getAttribute('href');
      var destino = id && id.charAt(0) === '#' ? raiz.querySelector(id) : null;
      if (destino) {
        e.preventDefault();
        destino.classList.add('marcas-uc__grupo--abierto');
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-running"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-running-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-rn-tab]');
  var paneles = raiz.querySelectorAll('[data-rn-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-rn-tab');
      tabs.forEach(function (t) { t.classList.remove('running-uc__tab--activo'); });
      tab.classList.add('running-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('running-uc__panel--activo', p.getAttribute('data-rn-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paginaproductouc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var datosEl = raiz.querySelector('[data-prod-variantes]');
    if (!datosEl) return;
    var variantes = [];
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var formato = raiz.getAttribute('data-money-format') || '${{amount}}';
    var soloDefault = raiz.getAttribute('data-solo-default') === '1';

    var form = raiz.querySelector('[data-prod-form]');
    var idInput = raiz.querySelector('[data-prod-id]');
    var precioEl = raiz.querySelector('[data-prod-precio]');
    var antesEl = raiz.querySelector('[data-prod-antes]');
    var badgeEl = raiz.querySelector('[data-prod-badge]');
    var avisoEl = raiz.querySelector('[data-prod-aviso]');
    var btnAgregar = raiz.querySelector('[data-prod-agregar]');
    var btnAgregarTexto = raiz.querySelector('[data-prod-agregar-texto]');
    var btnComprar = raiz.querySelector('[data-prod-comprar]');
    var grupos = raiz.querySelectorAll('[data-prod-opcion]');
    var principal = raiz.querySelector('[data-prod-principal]');
    var thumbs = raiz.querySelectorAll('[data-prod-thumb]');
    var dots = raiz.querySelectorAll('[data-prod-dot]');
    var cantInput = raiz.querySelector('[data-prod-cant]');

    var stickyEl = raiz.querySelector('[data-prod-sticky]');
    var stickyPrecio = raiz.querySelector('[data-prod-sticky-precio]');
    var stickyImg = raiz.querySelector('[data-prod-sticky-img]');
    var stickySelects = raiz.querySelectorAll('[data-prod-sticky-select]');
    var stickyAdd = raiz.querySelector('[data-prod-sticky-add]');
    var stickyAddTexto = raiz.querySelector('[data-prod-sticky-add-texto]');

    var textoAgregar = btnAgregarTexto ? btnAgregarTexto.textContent : 'Agregar';
    var textoAgotado = raiz.getAttribute('data-texto-agotado') || 'AGOTADO';
    var textoElegir = raiz.getAttribute('data-texto-elegir') || 'Selecciona tu talla';
    var hayDisponibles = variantes.some(function (v) { return v.available; });
    var seleccion = [];
    for (var s = 0; s < grupos.length; s++) { seleccion.push(''); }

    function formatearDinero(centavos) {
      var num = Number(centavos);
      function sep(n, p, miles, dec) {
        p = p == null ? 2 : p; miles = miles || ','; dec = dec || '.';
        if (isNaN(n)) return '0';
        n = (n / 100).toFixed(p);
        var partes = n.split('.');
        var ent = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
        return ent + (partes[1] ? dec + partes[1] : '');
      }
      var ph = /\{\{\s*(\w+)\s*\}\}/;
      var m = formato.match(ph);
      if (!m) return formato;
      var val = '';
      switch (m[1]) {
        case 'amount': val = sep(num, 2); break;
        case 'amount_no_decimals': val = sep(num, 0); break;
        case 'amount_with_comma_separator': val = sep(num, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = sep(num, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': val = sep(num, 2, "'", '.'); break;
        case 'amount_with_space_separator': val = sep(num, 2, ' ', '.'); break;
        case 'amount_no_decimals_with_space_separator': val = sep(num, 0, ' ', '.'); break;
        default: val = sep(num, 2);
      }
      return formato.replace(ph, val);
    }

    function varianteActual() {
      if (soloDefault) return variantes[0];
      for (var k = 0; k < seleccion.length; k++) { if (!seleccion[k]) return null; }
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      }) || null;
    }

    function valorDisponible(pos, val) {
      return variantes.some(function (v) {
        if (!v.available) return false;
        if (v.options[pos] !== val) return false;
        for (var j = 0; j < seleccion.length; j++) {
          if (j !== pos && seleccion[j] && v.options[j] !== seleccion[j]) return false;
        }
        return true;
      });
    }

    function pintarPrecio(v) {
      if (precioEl) {
        precioEl.textContent = formatearDinero(v.price);
        var enOferta = v.compare && v.compare > v.price;
        precioEl.classList.toggle('producto-uc__precio--oferta', !!enOferta);
        if (antesEl) {
          if (enOferta) {
            antesEl.textContent = formatearDinero(v.compare);
            antesEl.hidden = false;
          } else {
            antesEl.hidden = true;
          }
        }
        if (badgeEl) {
          if (enOferta) {
            var pct = Math.round((1 - v.price / v.compare) * 100);
            badgeEl.textContent = '-' + pct + '%';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
      }
      if (stickyPrecio) stickyPrecio.textContent = formatearDinero(v.price);
    }

    var imagenes = [];
    thumbs.forEach(function (t) {
      imagenes.push({ id: t.getAttribute('data-media-id'), src: t.getAttribute('data-src') });
    });
    var indiceImagen = 0;

    function irAImagen(i, animar) {
      if (!imagenes.length) return;
      if (i < 0) i = imagenes.length - 1;
      if (i >= imagenes.length) i = 0;
      indiceImagen = i;
      if (principal) {
        if (animar) {
          principal.classList.add('prod-cambiando');
          setTimeout(function () {
            principal.src = imagenes[i].src;
            principal.classList.remove('prod-cambiando');
          }, 130);
        } else {
          principal.src = imagenes[i].src;
        }
      }
      thumbs.forEach(function (t, ti) { t.classList.toggle('prod-activo', ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle('prod-activo', di === i); });
      var thumbActivo = thumbs[i];
      if (thumbActivo && thumbActivo.scrollIntoView) {
        try { thumbActivo.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      }
    }

    function cambiarImagen(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < imagenes.length; i++) {
        if (imagenes[i].id == mediaId) { irAImagen(i, true); return; }
      }
    }

    function actualizarSticky(v, completo) {
      if (!stickyEl) return;
      if (stickyImg && v && v.media) {
        for (var i = 0; i < imagenes.length; i++) {
          if (imagenes[i].id == v.media) { stickyImg.src = imagenes[i].src; break; }
        }
      }
      stickySelects.forEach(function (sel) {
        var pos = parseInt(sel.getAttribute('data-pos'), 10);
        if (seleccion[pos] && sel.value !== seleccion[pos]) sel.value = seleccion[pos];
        Array.prototype.forEach.call(sel.options, function (op) {
          if (!op.value) return;
          op.disabled = !valorDisponible(pos, op.value);
        });
      });
      if (stickyAdd) {
        if (btnAgregar) stickyAdd.disabled = btnAgregar.disabled && !hayDisponibles;
        else stickyAdd.disabled = false;
      }
      if (stickyAddTexto && btnAgregarTexto) stickyAddTexto.textContent = btnAgregarTexto.textContent;
    }

    function actualizarMarcas() {
      grupos.forEach(function (grupo) {
        var pos = parseInt(grupo.getAttribute('data-pos'), 10);
        var botones = grupo.querySelectorAll('[data-prod-valor]');
        botones.forEach(function (btn) {
          var val = btn.getAttribute('data-valor');
          var disp = valorDisponible(pos, val);
          btn.classList.toggle('prod-agotado', !disp);
        });
        var valEl = grupo.querySelector('[data-prod-opcion-valor]');
        if (valEl) valEl.textContent = seleccion[pos] ? seleccion[pos] : '';
      });
    }

    function fijarEstado() {
      var v = varianteActual();
      var completo = true;
      if (!soloDefault) {
        for (var k = 0; k < seleccion.length; k++) { if (!seleccion[k]) { completo = false; break; } }
      }

      if (!completo) {
        if (idInput) idInput.value = '';
        if (hayDisponibles) {
          if (avisoEl) avisoEl.hidden = false;
          if (btnAgregar) { btnAgregar.disabled = true; btnAgregar.classList.add('prod-elegir'); }
          if (btnComprar) { btnComprar.disabled = true; btnComprar.classList.add('prod-elegir'); }
          if (btnAgregarTexto) btnAgregarTexto.textContent = textoElegir;
        } else {
          if (avisoEl) avisoEl.hidden = true;
          if (btnAgregar) { btnAgregar.disabled = true; btnAgregar.classList.remove('prod-elegir'); }
          if (btnComprar) { btnComprar.disabled = true; btnComprar.classList.remove('prod-elegir'); }
          if (btnAgregarTexto) btnAgregarTexto.textContent = textoAgotado;
        }
        actualizarSticky(v, completo);
        return;
      }

      if (avisoEl) avisoEl.hidden = true;

      if (!v || !v.available) {
        if (idInput) idInput.value = v ? v.id : '';
        if (btnAgregar) { btnAgregar.disabled = true; btnAgregar.classList.remove('prod-elegir'); }
        if (btnComprar) { btnComprar.disabled = true; btnComprar.classList.remove('prod-elegir'); }
        if (btnAgregarTexto) btnAgregarTexto.textContent = textoAgotado;
        actualizarSticky(v, completo);
        return;
      }

      if (idInput) idInput.value = v.id;
      if (btnAgregar) { btnAgregar.disabled = false; btnAgregar.classList.remove('prod-elegir'); }
      if (btnComprar) { btnComprar.disabled = false; btnComprar.classList.remove('prod-elegir'); }
      if (btnAgregarTexto) btnAgregarTexto.textContent = textoAgregar;
      pintarPrecio(v);
      if (v.media) cambiarImagen(v.media);
      actualizarSticky(v, completo);
    }

    function elegirValor(pos, val) {
      seleccion[pos] = val;
      grupos.forEach(function (grupo) {
        if (parseInt(grupo.getAttribute('data-pos'), 10) !== pos) return;
        grupo.querySelectorAll('[data-prod-valor]').forEach(function (b) {
          b.classList.toggle('prod-activo', b.getAttribute('data-valor') === val);
        });
      });
      actualizarMarcas();
      fijarEstado();
    }

    grupos.forEach(function (grupo) {
      var pos = parseInt(grupo.getAttribute('data-pos'), 10);
      grupo.querySelectorAll('[data-prod-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('prod-agotado')) return;
          elegirValor(pos, btn.getAttribute('data-valor'));
        });
      });
    });

    stickySelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var pos = parseInt(sel.getAttribute('data-pos'), 10);
        if (!sel.value) return;
        elegirValor(pos, sel.value);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        irAImagen(parseInt(thumb.getAttribute('data-index'), 10), true);
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        irAImagen(parseInt(dot.getAttribute('data-index'), 10), true);
      });
    });
    var visorPrev = raiz.querySelector('[data-prod-visor-prev]');
    var visorNext = raiz.querySelector('[data-prod-visor-next]');
    if (visorPrev) visorPrev.addEventListener('click', function () { irAImagen(indiceImagen - 1, true); });
    if (visorNext) visorNext.addEventListener('click', function () { irAImagen(indiceImagen + 1, true); });

    var visor = raiz.querySelector('[data-prod-visor]');
    if (visor && imagenes.length > 1) {
      var xIni = 0, yIni = 0, arrastrando = false;
      visor.addEventListener('touchstart', function (e) {
        xIni = e.touches[0].clientX; yIni = e.touches[0].clientY; arrastrando = true;
      }, { passive: true });
      visor.addEventListener('touchend', function (e) {
        if (!arrastrando) return;
        arrastrando = false;
        var dx = e.changedTouches[0].clientX - xIni;
        var dy = e.changedTouches[0].clientY - yIni;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) irAImagen(indiceImagen + 1, false);
          else irAImagen(indiceImagen - 1, false);
        }
      }, { passive: true });
    }

    var menos = raiz.querySelector('[data-prod-menos]');
    var mas = raiz.querySelector('[data-prod-mas]');
    function cant() { return Math.max(1, parseInt(cantInput ? cantInput.value : '1', 10) || 1); }
    if (menos) menos.addEventListener('click', function () { if (cantInput) cantInput.value = Math.max(1, cant() - 1); });
    if (mas) mas.addEventListener('click', function () { if (cantInput) cantInput.value = cant() + 1; });

    if (btnComprar) {
      btnComprar.addEventListener('click', function () {
        if (btnComprar.disabled) return;
        var id = idInput ? idInput.value : '';
        if (!id) return;
        btnComprar.classList.add('prod-cargando');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: cant() })
        }).then(function (r) { return r.json(); }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          btnComprar.classList.remove('prod-cargando');
        });
      });
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (btnAgregar && btnAgregar.disabled) {
          var destino = raiz.querySelector('.producto-uc__opciones') || form;
          if (destino && destino.scrollIntoView) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (avisoEl && hayDisponibles) avisoEl.hidden = false;
          return;
        }
        if (btnAgregar) btnAgregar.click();
      });
    }

    if (soloDefault) {
      fijarEstado();
    } else {
      actualizarMarcas();
      fijarEstado();
    }

    if (stickyEl && btnAgregar && 'IntersectionObserver' in window) {
      var anclaSticky = raiz.querySelector('.producto-uc__botones') || btnAgregar;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var pasado = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyEl.classList.toggle('prod-visible', pasado);
        });
      }, { threshold: 0 });
      obs.observe(anclaSticky);
    }

    var destacado = raiz.querySelector('[data-prod-destacado]');
    if (destacado) {
      var items = destacado.querySelectorAll('[data-prod-destacado-item]');
      if (items.length > 1) {
        var idxDest = 0;
        setInterval(function () {
          items[idxDest].classList.remove('prod-activo');
          idxDest = (idxDest + 1) % items.length;
          items[idxDest].classList.add('prod-activo');
        }, 4500);
      }
    }

    var irResenas = raiz.querySelector('[data-prod-ir-resenas]');
    var bloqueResenas = raiz.querySelector('[data-prod-resenas]');
    if (irResenas && bloqueResenas) {
      irResenas.addEventListener('click', function () {
        bloqueResenas.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var track = raiz.querySelector('[data-prod-resenas-track]');
    if (track) {
      var rPrev = raiz.querySelector('[data-prod-resenas-prev]');
      var rNext = raiz.querySelector('[data-prod-resenas-next]');
      function pasoResena() {
        var card = track.querySelector('.producto-uc__resena');
        return card ? card.getBoundingClientRect().width + 14 : 300;
      }
      if (rPrev) rPrev.addEventListener('click', function () { track.scrollBy({ left: -pasoResena(), behavior: 'smooth' }); });
      if (rNext) rNext.addEventListener('click', function () { track.scrollBy({ left: pasoResena(), behavior: 'smooth' }); });
    }

    var viendoActivo = raiz.getAttribute('data-viendo-activo') === '1';
    var viendoNum = raiz.querySelector('[data-prod-viendo-num]');
    if (viendoActivo && viendoNum) {
      var vMin = parseInt(raiz.getAttribute('data-viendo-min'), 10) || 8;
      var vMax = parseInt(raiz.getAttribute('data-viendo-max'), 10) || 30;
      if (vMax < vMin) vMax = vMin;
      function aleatorio(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
      var actual = aleatorio(vMin, vMax);
      viendoNum.textContent = actual;
      setInterval(function () {
        var delta = aleatorio(-2, 2);
        actual += delta;
        if (actual < vMin) actual = vMin + aleatorio(0, 2);
        if (actual > vMax) actual = vMax - aleatorio(0, 2);
        viendoNum.textContent = actual;
      }, 4000);
    }

    var tablaModal = raiz.querySelector('[data-prod-tabla-modal]');
    if (tablaModal) {
      var abrirBtns = raiz.querySelectorAll('[data-prod-tabla-abrir]');
      var cerrarBtns = raiz.querySelectorAll('[data-prod-tabla-cerrar]');
      function abrirTabla() {
        tablaModal.classList.add('prod-abierto');
        document.body.style.overflow = 'hidden';
      }
      function cerrarTabla() {
        tablaModal.classList.remove('prod-abierto');
        document.body.style.overflow = '';
      }
      abrirBtns.forEach(function (b) { b.addEventListener('click', abrirTabla); });
      cerrarBtns.forEach(function (b) { b.addEventListener('click', cerrarTabla); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && tablaModal.classList.contains('prod-abierto')) cerrarTabla();
      });
    }

    var entrega = raiz.querySelector('[data-prod-entrega]');
    if (entrega) {
      var procDias = parseInt(raiz.getAttribute('data-en-proc'), 10) || 4;
      var entregaDias = parseInt(raiz.getAttribute('data-en-entrega'), 10) || 4;
      var procOffset = parseInt(raiz.getAttribute('data-en-offset'), 10);
      if (isNaN(procOffset)) procOffset = 1;
      var formatoEn = raiz.getAttribute('data-en-formato') || 'dmy';
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

      function sumarDias(base, n) {
        var d = new Date(base.getTime());
        d.setDate(d.getDate() + n);
        return d;
      }
      function dosD(n) { return n < 10 ? '0' + n : '' + n; }
      function cortoEn(d) { return meses[d.getMonth()] + ' ' + d.getDate(); }
      function rangoEn(a, b) {
        if (a.getTime() === b.getTime()) return cortoEn(a);
        if (a.getMonth() === b.getMonth()) return meses[a.getMonth()] + ' ' + a.getDate() + ' - ' + b.getDate();
        return cortoEn(a) + ' - ' + cortoEn(b);
      }
      function largoEn(d) {
        var dd = dosD(d.getDate()), mm = dosD(d.getMonth() + 1), yy = d.getFullYear();
        return formatoEn === 'mdy' ? (mm + '/' + dd + '/' + yy) : (dd + '/' + mm + '/' + yy);
      }

      var hoy = new Date();
      var procIni = sumarDias(hoy, procOffset);
      var procFin = sumarDias(hoy, procOffset + Math.max(0, procDias - 1));
      var entIni = sumarDias(procFin, 1);
      var entFin = sumarDias(procFin, Math.max(1, entregaDias));

      var ep1 = entrega.querySelector('[data-en-paso="1"]');
      var ep2 = entrega.querySelector('[data-en-paso="2"]');
      var ep3 = entrega.querySelector('[data-en-paso="3"]');
      var ef1 = entrega.querySelector('[data-en-fecha1]');
      var ef2 = entrega.querySelector('[data-en-fecha2]');
      if (ep1) ep1.textContent = cortoEn(hoy);
      if (ep2) ep2.textContent = rangoEn(procIni, procFin);
      if (ep3) ep3.textContent = rangoEn(entIni, entFin);
      if (ef1) ef1.textContent = largoEn(entIni);
      if (ef2) ef2.textContent = largoEn(entFin);
    }

    var reco = raiz.querySelector('[data-prod-relacionados]');
    if (reco && raiz.getAttribute('data-reco-activo') === '1' && !reco.querySelector('.producto-uc__reco-grid')) {
      var recoUrl = raiz.getAttribute('data-reco-url');
      var recoId = raiz.getAttribute('data-reco-id');
      var recoLim = raiz.getAttribute('data-reco-limite') || '8';
      var recoSec = raiz.getAttribute('data-section-id');
      if (recoUrl && recoId) {
        var url = recoUrl + '?section_id=' + encodeURIComponent(recoSec) + '&product_id=' + encodeURIComponent(recoId) + '&limit=' + encodeURIComponent(recoLim) + '&intent=related';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-prod-relacionados]');
          if (nuevo && nuevo.innerHTML.trim()) reco.innerHTML = nuevo.innerHTML;
        }).catch(function () {});
      }
    }
  }

  document.querySelectorAll('[data-producto-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-prod-listo')) return;
    raiz.setAttribute('data-prod-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prueba-social"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-social-uc]');
  if (!raiz) return;
  var lb = raiz.querySelector('[data-social-lightbox]');
  var lbImg = raiz.querySelector('[data-social-lb-img]');

  function abrir(src) {
    if (!lb || !src) return;
    lbImg.setAttribute('src', src);
    lb.classList.add('uc-activo');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function cerrar() {
    if (!lb) return;
    lb.classList.remove('uc-activo');
    lb.setAttribute('aria-hidden', 'true');
    lbImg.setAttribute('src', '');
    document.body.style.overflow = '';
  }

  raiz.querySelectorAll('[data-social-abrir]').forEach(function (card) {
    card.addEventListener('click', function () {
      abrir(card.getAttribute('data-social-img'));
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        abrir(card.getAttribute('data-social-img'));
      }
    });
  });

  var cerrarBtn = raiz.querySelector('[data-social-cerrar]');
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) cerrar(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recomendados-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(raiz) {
    var pista = raiz.querySelector('[data-rec-pista]');
    var thumb = raiz.querySelector('[data-rec-thumb]');
    var prev = raiz.querySelector('[data-rec-prev]');
    var next = raiz.querySelector('[data-rec-next]');
    if (!pista) return;

    function maxScroll() { return pista.scrollWidth - pista.clientWidth; }

    function actualizar() {
      var ancho = pista.scrollWidth;
      if (ancho <= 0) return;
      var visible = (pista.clientWidth / ancho) * 100;
      if (visible > 100) visible = 100;
      if (visible < 8) visible = 8;
      var rango = 100 - visible;
      var fin = maxScroll();
      var avance = fin > 0 ? (pista.scrollLeft / fin) : 0;
      if (thumb) {
        thumb.style.setProperty('--rec-thumb-ancho', visible + '%');
        thumb.style.setProperty('--rec-thumb-left', (avance * rango) + '%');
      }
      if (prev) prev.classList.toggle('rec-inactiva', pista.scrollLeft <= 2);
      if (next) next.classList.toggle('rec-inactiva', pista.scrollLeft >= fin - 2);
    }

    function desplazar(dir) {
      var card = pista.querySelector('.rec-uc__card');
      var paso = card ? (card.offsetWidth + 16) : pista.clientWidth * 0.8;
      var cantidad = Math.max(1, Math.floor(pista.clientWidth / paso)) * paso;
      pista.scrollBy({ left: dir * cantidad, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { desplazar(-1); });
    if (next) next.addEventListener('click', function () { desplazar(1); });
    pista.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); });
    window.addEventListener('resize', actualizar);
    setTimeout(actualizar, 300);

    var progreso = raiz.querySelector('[data-rec-progreso]');
    var scrubeando = false;
    function scrubA(clientX) {
      var r = progreso.getBoundingClientRect();
      if (r.width <= 0) return;
      var ratio = (clientX - r.left) / r.width;
      ratio = Math.max(0, Math.min(1, ratio));
      pista.scrollLeft = ratio * maxScroll();
      actualizar();
    }
    if (progreso) {
      progreso.addEventListener('pointerdown', function (e) {
        scrubeando = true;
        try { progreso.setPointerCapture(e.pointerId); } catch (err) {}
        scrubA(e.clientX);
      });
      progreso.addEventListener('pointermove', function (e) { if (scrubeando) scrubA(e.clientX); });
      progreso.addEventListener('pointerup', function () { scrubeando = false; });
      progreso.addEventListener('pointercancel', function () { scrubeando = false; });
    }

    var arrastrando = false, inicioX = 0, inicioScroll = 0, movido = false;
    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      arrastrando = true; movido = false;
      inicioX = e.clientX; inicioScroll = pista.scrollLeft;
      pista.classList.add('rec-arrastrando');
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var dx = e.clientX - inicioX;
      if (Math.abs(dx) > 3) movido = true;
      pista.scrollLeft = inicioScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('rec-arrastrando');
    });
    pista.addEventListener('click', function (e) {
      if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; }
    }, true);

    raiz.querySelectorAll('[data-rec-card]').forEach(function (card) {
      card.addEventListener('touchstart', function () { card.classList.add('rec-segunda'); }, { passive: true });
      card.addEventListener('touchend', function () {
        setTimeout(function () { card.classList.remove('rec-segunda'); }, 1200);
      });
    });

    actualizar();
  }

  function cargar(raiz) {
    var pid = raiz.getAttribute('data-product-id');
    var sid = raiz.getAttribute('data-section-id');
    var base = raiz.getAttribute('data-url') || '/recommendations/products';
    var limite = raiz.getAttribute('data-limit') || '10';
    var intent = raiz.getAttribute('data-intent') || 'related';
    if (!pid || pid === '') { raiz.style.display = 'none'; return; }

    if (raiz.querySelector('[data-rec-pista]')) {
      iniciarCarrusel(raiz);
      return;
    }

    var url = base + '?section_id=' + encodeURIComponent(sid) + '&product_id=' + encodeURIComponent(pid) + '&intent=' + encodeURIComponent(intent) + '&limit=' + encodeURIComponent(limite);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresca = doc.querySelector('[data-recomendados-uc]');
        if (!fresca) { raiz.style.display = 'none'; return; }
        raiz.innerHTML = fresca.innerHTML;
        if (raiz.querySelector('[data-rec-card]')) {
          iniciarCarrusel(raiz);
        } else {
          raiz.style.display = 'none';
        }
      })
      .catch(function () { raiz.style.display = 'none'; });
  }

  document.querySelectorAll('[data-recomendados-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-rec-listo')) return;
    raiz.setAttribute('data-rec-listo', '1');
    cargar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["todas-colecciones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('[data-cols-uc]').forEach(function (raiz) {
      var indice = raiz.querySelector('[data-cols-indice]');
      if (!indice || indice.getAttribute('data-listo') === '1') return;
      indice.setAttribute('data-listo', '1');
      indice.addEventListener('click', function (e) {
        var boton = e.target.closest ? e.target.closest('.cols-uc__letra') : null;
        if (!boton) return;
        var L = (boton.getAttribute('data-letra') || '').trim();
        indice.querySelectorAll('.cols-uc__letra').forEach(function (x) {
          x.classList.toggle('cols-uc__letra--activa', x === boton);
        });
        raiz.querySelectorAll('.cols-uc__card').forEach(function (c) {
          var cl = (c.getAttribute('data-letra') || '').trim();
          c.style.display = (L === 'TODAS' || cl === L) ? '' : 'none';
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-asistente-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE = 'uc_chat_visto';

  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var panel = raiz.querySelector('[data-uc-chat-panel]');
    var hilo = raiz.querySelector('[data-uc-chat-hilo]');
    var opciones = raiz.querySelector('[data-uc-chat-opciones]');
    var globo = raiz.querySelector('[data-uc-chat-globo]');
    var datos = raiz.querySelector('[data-uc-chat-datos]');
    if (!panel || !hilo || !opciones || !datos) return;

    var saludoNodo = datos.querySelector('[data-uc-chat-saludo]');
    var respuestas = datos.querySelectorAll('[data-uc-chat-respuesta]');
    var retraso = parseInt(raiz.getAttribute('data-retraso'), 10);
    if (isNaN(retraso)) retraso = 8;
    var demora = parseInt(raiz.getAttribute('data-escribiendo'), 10);
    if (isNaN(demora)) demora = 900;
    var textoVolver = raiz.getAttribute('data-texto-volver') || '';
    var textoBorrar = raiz.getAttribute('data-texto-borrar') || 'Borrar';
    var textoOpciones = raiz.getAttribute('data-texto-opciones') || '';
    var arrancado = false;

    function abajo() {
      hilo.scrollTop = hilo.scrollHeight;
    }

    function mensajeBot(html, caja) {
      var linea = document.createElement('div');
      linea.className = 'uc-asis__linea uc-asis__linea--bot';
      var burbuja = document.createElement('div');
      burbuja.className = 'uc-asis__burbuja';
      burbuja.innerHTML = html;
      linea.appendChild(burbuja);
      (caja || hilo).appendChild(linea);
      abajo();
    }

    function crearIntercambio() {
      var caja = document.createElement('div');
      caja.className = 'uc-asis__intercambio';
      hilo.appendChild(caja);
      return caja;
    }

    function borrarIntercambio(caja) {
      caja.classList.add('uc-asis__intercambio--saliendo');
      window.setTimeout(function () {
        if (caja.parentNode) caja.parentNode.removeChild(caja);
        if (!hilo.querySelector('.uc-asis__linea')) {
          arrancado = false;
          arrancar();
        }
      }, 260);
    }

    function mensajeUsuario(texto, caja) {
      var linea = document.createElement('div');
      linea.className = 'uc-asis__linea uc-asis__linea--usuario';

      var borrar = document.createElement('button');
      borrar.type = 'button';
      borrar.className = 'uc-asis__borrar';
      borrar.setAttribute('aria-label', textoBorrar);
      borrar.title = textoBorrar;
      borrar.innerHTML = '<svg viewBox="0 0 24 24" fill="none" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"></path></svg>';
      borrar.addEventListener('click', function () {
        borrarIntercambio(caja);
      });

      var burbuja = document.createElement('div');
      burbuja.className = 'uc-asis__burbuja';
      burbuja.textContent = texto;

      linea.appendChild(borrar);
      linea.appendChild(burbuja);
      (caja || hilo).appendChild(linea);
      abajo();
    }

    function escribiendo(caja) {
      var linea = document.createElement('div');
      linea.className = 'uc-asis__linea uc-asis__linea--bot';
      var burbuja = document.createElement('div');
      burbuja.className = 'uc-asis__burbuja uc-asis__puntos';
      burbuja.innerHTML = '<span></span><span></span><span></span>';
      linea.appendChild(burbuja);
      (caja || hilo).appendChild(linea);
      abajo();
      return linea;
    }

    function pintarOpciones(conVolver) {
      opciones.innerHTML = '';

      respuestas.forEach(function (nodo) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'uc-asis__chip';

        var etiqueta = document.createElement('span');
        etiqueta.textContent = nodo.getAttribute('data-chip') || nodo.getAttribute('data-pregunta') || '';

        var flecha = document.createElement('span');
        flecha.className = 'uc-asis__chip-flecha';
        flecha.setAttribute('aria-hidden', 'true');
        flecha.textContent = '>';

        chip.appendChild(etiqueta);
        chip.appendChild(flecha);
        chip.addEventListener('click', function () {
          responder(nodo);
        });
        opciones.appendChild(chip);
      });

      if (conVolver && textoVolver) {
        var volver = document.createElement('button');
        volver.type = 'button';
        volver.className = 'uc-asis__chip uc-asis__chip--volver';
        volver.textContent = textoVolver;
        volver.addEventListener('click', limpiarTodo);
        opciones.appendChild(volver);
      }
    }

    function responder(nodo) {
      var caja = crearIntercambio();
      mensajeUsuario(nodo.getAttribute('data-pregunta') || '', caja);
      opciones.innerHTML = '';
      var puntos = escribiendo(caja);

      window.setTimeout(function () {
        if (puntos.parentNode) puntos.parentNode.removeChild(puntos);
        mensajeBot(nodo.innerHTML, caja);
        if (textoOpciones) {
          window.setTimeout(function () {
            mensajeBot('<strong>' + textoOpciones + '</strong>', caja);
            pintarOpciones(true);
          }, 260);
        } else {
          pintarOpciones(true);
        }
      }, demora);
    }

    function arrancar() {
      if (arrancado) return;
      arrancado = true;
      var caja = crearIntercambio();
      var puntos = escribiendo(caja);
      window.setTimeout(function () {
        if (puntos.parentNode) puntos.parentNode.removeChild(puntos);
        if (saludoNodo) mensajeBot(saludoNodo.innerHTML, caja);
        pintarOpciones(false);
      }, demora);
    }

    function limpiarTodo() {
      hilo.innerHTML = '';
      arrancado = false;
      arrancar();
    }

    function abrir() {
      panel.hidden = false;
      raiz.classList.add('uc-asis--abierto');
      if (globo) globo.hidden = true;
      try { window.localStorage.setItem(CLAVE, '1'); } catch (e) {}
      arrancar();
    }

    function cerrar() {
      panel.hidden = true;
      raiz.classList.remove('uc-asis--abierto');
    }

    raiz.addEventListener('click', function (evento) {
      if (evento.target.closest('[data-uc-chat-quitar-globo]')) {
        evento.stopPropagation();
        if (globo) globo.hidden = true;
        try { window.localStorage.setItem(CLAVE, '1'); } catch (e) {}
        return;
      }
      if (evento.target.closest('[data-uc-chat-limpiar]')) {
        limpiarTodo();
        return;
      }
      if (evento.target.closest('[data-uc-chat-cerrar]')) {
        cerrar();
        return;
      }
      if (evento.target.closest('[data-uc-chat-abrir]')) {
        if (panel.hidden) {
          abrir();
        } else {
          cerrar();
        }
        return;
      }
      if (evento.target.closest('[data-uc-chat-globo]')) {
        abrir();
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && !panel.hidden) cerrar();
    });

    var visto = false;
    try { visto = window.localStorage.getItem(CLAVE) === '1'; } catch (e) {}

    if (globo && !visto && retraso >= 0) {
      window.setTimeout(function () {
        if (panel.hidden) globo.hidden = false;
      }, retraso * 1000);
    }
  }

  function iniciarTodos(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-chat]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-busqueda"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_BUSQUEDAS = 'uc_busquedas';
  var CLAVE_VISTOS = 'uc_recientes';
  var CLASE_BLOQUEO = 'uc-buscar-bloqueo';

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function conAncho(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function asegurarEstilos() {
    if (document.getElementById('uc-buscar-estilos')) return;
    var estilo = document.createElement('style');
    estilo.id = 'uc-buscar-estilos';
    estilo.textContent = '.' + CLASE_BLOQUEO + ' { overflow: hidden !important; }';
    document.head.appendChild(estilo);
  }

  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');
    asegurarEstilos();

    var seccion = raiz.getAttribute('data-seccion');
    var rutaPredictiva = raiz.getAttribute('data-ruta-predictiva') || '/search/suggest';
    var rutaBusqueda = raiz.getAttribute('data-ruta-busqueda') || '/search';
    var selectores = raiz.getAttribute('data-selectores') || '';
    var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 8;
    var limiteVistos = parseInt(raiz.getAttribute('data-limite-vistos'), 10) || 8;
    var minimo = parseInt(raiz.getAttribute('data-minimo'), 10) || 2;
    var campos = (raiz.getAttribute('data-campos') || '').replace(/\s+/g, '');
    var textoResultados = raiz.getAttribute('data-texto-resultados') || '';
    var textoVerTodo = raiz.getAttribute('data-texto-ver-todo') || '';

    var campo = raiz.querySelector('[data-uc-campo]');
    var forma = raiz.querySelector('[data-uc-forma]');
    var limpiar = raiz.querySelector('[data-uc-limpiar]');
    var bloqueRecientes = raiz.querySelector('[data-uc-bloque-recientes]');
    var listaRecientes = raiz.querySelector('[data-uc-lista-recientes]');
    var bloqueSugerencias = raiz.querySelector('[data-uc-bloque-sugerencias]');
    var listaSugerencias = raiz.querySelector('[data-uc-lista-sugerencias]');
    var bloqueVistos = raiz.querySelector('[data-uc-bloque-vistos]');
    var listaVistos = raiz.querySelector('[data-uc-lista-vistos]');
    var bloquePopulares = raiz.querySelector('[data-uc-bloque-populares]');
    var bloqueResultados = raiz.querySelector('[data-uc-bloque-resultados]');
    var tituloResultados = raiz.querySelector('[data-uc-titulo-resultados]');
    var listaProductos = raiz.querySelector('[data-uc-lista-productos]');
    var sinResultados = raiz.querySelector('[data-uc-sin-resultados]');
    var verTodo = raiz.querySelector('[data-uc-ver-todo]');

    var sugerenciasBase = listaSugerencias ? listaSugerencias.innerHTML : '';
    var temporizador = null;
    var peticion = null;

    function leer(clave) {
      try { return JSON.parse(window.localStorage.getItem(clave)) || []; } catch (e) { return []; }
    }

    function guardar(clave, lista) {
      try { window.localStorage.setItem(clave, JSON.stringify(lista)); } catch (e) {}
    }

    function guardarBusqueda(texto) {
      var limpio = String(texto || '').trim();
      if (!limpio) return;
      var lista = leer(CLAVE_BUSQUEDAS).filter(function (t) {
        return String(t).toLowerCase() !== limpio.toLowerCase();
      });
      lista.unshift(limpio);
      guardar(CLAVE_BUSQUEDAS, lista.slice(0, 10));
    }

    function pintarRecientes() {
      if (!bloqueRecientes || !listaRecientes) return;
      var lista = leer(CLAVE_BUSQUEDAS);
      if (!lista.length) {
        bloqueRecientes.hidden = true;
        return;
      }
      listaRecientes.innerHTML = lista.map(function (texto) {
        return '<span class="uc-buscar__chip" data-uc-reciente data-texto="' + esc(texto) + '">' +
          esc(texto) +
          '<button type="button" class="uc-buscar__chip-quitar" data-uc-quitar-reciente data-texto="' + esc(texto) + '" aria-label="Quitar">' +
          '<svg viewBox="0 0 24 24" fill="none" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"></path></svg>' +
          '</button></span>';
      }).join('');
      bloqueRecientes.hidden = false;
    }

    function pintarVistos() {
      if (!bloqueVistos || !listaVistos) return;
      var lista = leer(CLAVE_VISTOS).slice(0, limiteVistos);
      if (!lista.length) {
        bloqueVistos.hidden = true;
        return;
      }
      listaVistos.innerHTML = lista.map(function (p) {
        var img = p.image ? '<img src="' + conAncho(p.image, 240) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
        return '<a class="uc-buscar__producto" href="' + esc(p.url) + '">' +
          '<span class="uc-buscar__producto-imagen">' + img + '</span>' +
          '<span class="uc-buscar__producto-datos"><span class="uc-buscar__producto-nombre">' + esc(p.title) + '</span></span>' +
        '</a>';
      }).join('');
      bloqueVistos.hidden = false;
    }

    function modoInicial() {
      if (bloqueResultados) bloqueResultados.hidden = true;
      if (bloquePopulares) bloquePopulares.hidden = false;
      if (bloqueSugerencias) bloqueSugerencias.hidden = false;
      if (listaSugerencias) listaSugerencias.innerHTML = sugerenciasBase;
      if (limpiar) limpiar.hidden = true;
      pintarRecientes();
      pintarVistos();
    }

    function modoResultados(termino) {
      if (bloquePopulares) bloquePopulares.hidden = true;
      if (bloqueRecientes) bloqueRecientes.hidden = true;
      if (bloqueVistos) bloqueVistos.hidden = true;
      if (bloqueResultados) bloqueResultados.hidden = false;
      if (tituloResultados) {
        tituloResultados.textContent = textoResultados.replace('{termino}', termino);
      }
      if (verTodo) {
        verTodo.textContent = textoVerTodo.replace('{termino}', termino);
        verTodo.href = rutaBusqueda + '?q=' + encodeURIComponent(termino) + '&type=product';
        verTodo.hidden = false;
      }
    }

    function buscar(termino) {
      var url = rutaPredictiva +
        '?q=' + encodeURIComponent(termino) +
        '&section_id=' + encodeURIComponent(seccion) +
        '&resources[type]=product,query' +
        '&resources[limit]=' + limite +
        '&resources[options][unavailable_products]=last' +
        (campos ? '&resources[options][fields]=' + encodeURIComponent(campos) : '');

      if (peticion && peticion.abort) peticion.abort();
      var control = typeof AbortController === 'function' ? new AbortController() : null;
      peticion = control;

      fetch(url, control ? { signal: control.signal } : undefined)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sugeridas = doc.querySelector('[data-uc-resultado-sugerencias]');
          var productos = doc.querySelector('[data-uc-resultado-productos]');
          var conteo = doc.querySelector('[data-uc-resultado-conteo]');

          if (listaSugerencias) listaSugerencias.innerHTML = sugeridas ? sugeridas.innerHTML : '';
          if (bloqueSugerencias) bloqueSugerencias.hidden = !sugeridas || sugeridas.children.length === 0;
          if (listaProductos) listaProductos.innerHTML = productos ? productos.innerHTML : '';

          var vacio = conteo && conteo.getAttribute('data-vacio') === '1';
          if (sinResultados) sinResultados.hidden = !vacio;
        })
        .catch(function () {});
    }

    function alEscribir() {
      var termino = campo ? campo.value.trim() : '';
      if (limpiar) limpiar.hidden = termino.length === 0;
      window.clearTimeout(temporizador);

      if (termino.length < minimo) {
        modoInicial();
        return;
      }

      modoResultados(termino);
      temporizador = window.setTimeout(function () {
        buscar(termino);
      }, 260);
    }

    function abrir() {
      raiz.hidden = false;
      modoInicial();
      document.documentElement.classList.add(CLASE_BLOQUEO);
      window.requestAnimationFrame(function () {
        raiz.classList.add('uc-buscar--abierto');
        if (campo) campo.focus();
      });
    }

    function cerrar() {
      raiz.classList.remove('uc-buscar--abierto');
      document.documentElement.classList.remove(CLASE_BLOQUEO);
      window.setTimeout(function () {
        if (!raiz.classList.contains('uc-buscar--abierto')) raiz.hidden = true;
      }, 260);
    }

    if (campo) {
      campo.addEventListener('input', alEscribir);
    }

    if (limpiar) {
      limpiar.addEventListener('click', function () {
        if (campo) {
          campo.value = '';
          campo.focus();
        }
        alEscribir();
      });
    }

    if (forma) {
      forma.addEventListener('submit', function () {
        if (campo) guardarBusqueda(campo.value);
      });
    }

    raiz.addEventListener('click', function (evento) {
      var quitar = evento.target.closest('[data-uc-quitar-reciente]');
      if (quitar) {
        evento.preventDefault();
        evento.stopPropagation();
        var texto = quitar.getAttribute('data-texto');
        var lista = leer(CLAVE_BUSQUEDAS).filter(function (t) {
          return String(t) !== texto;
        });
        guardar(CLAVE_BUSQUEDAS, lista);
        pintarRecientes();
        return;
      }

      var reciente = evento.target.closest('[data-uc-reciente]');
      if (reciente) {
        if (campo) {
          campo.value = reciente.getAttribute('data-texto') || '';
          campo.focus();
        }
        alEscribir();
        return;
      }

      var sugerencia = evento.target.closest('[data-uc-sugerencia]');
      if (sugerencia) {
        guardarBusqueda(sugerencia.getAttribute('data-texto'));
        return;
      }

      if (evento.target.closest('[data-uc-cerrar]')) {
        cerrar();
      }
    });

    var limpiarTodo = raiz.querySelector('[data-uc-limpiar-recientes]');
    if (limpiarTodo) {
      limpiarTodo.addEventListener('click', function () {
        guardar(CLAVE_BUSQUEDAS, []);
        pintarRecientes();
      });
    }

    function esDisparador(nodo) {
      if (!nodo || !nodo.closest || !selectores) return null;
      return nodo.closest(selectores);
    }

    document.addEventListener('click', function (evento) {
      if (evento.defaultPrevented) return;
      if (evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
      var disparador = esDisparador(evento.target);
      if (!disparador || disparador.closest('[data-uc-buscar]')) return;
      evento.preventDefault();
      evento.stopPropagation();
      abrir();
    }, true);

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && !raiz.hidden) cerrar();
    });
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-buscar]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-cabecera-v6"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RETARDO_APERTURA = 110;
  var RETARDO_CIERRE = 190;
  var CLASE_BLOQUEO = 'uc-cabecera-bloqueo-scroll';
  var CONTADOR_PORTALES = 0;

  function asegurarEstilosBloqueo() {
    if (document.getElementById('uc-cabecera-estilos-bloqueo')) return;
    var estilo = document.createElement('style');
    estilo.id = 'uc-cabecera-estilos-bloqueo';
    estilo.textContent = '.' + CLASE_BLOQUEO + ' { overflow: hidden !important; }';
    document.head.appendChild(estilo);
  }

  function iniciarCabecera(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciada') === 'true') return;
    raiz.setAttribute('data-uc-iniciada', 'true');
    asegurarEstilosBloqueo();

    var envoltura = raiz.closest('.uc-cabecera-seccion') || raiz.parentElement;
    var barra = raiz.querySelector(':scope > .uc-cabecera__barra') || raiz.querySelector('.uc-cabecera__barra');
    var velo = raiz.querySelector('[data-uc-velo]');
    var cajon = raiz.querySelector('[data-uc-cajon]');
    var buscador = raiz.querySelector(':scope > [data-uc-buscador]') || raiz.querySelector('[data-uc-buscador]');
    var campoBusqueda = buscador ? buscador.querySelector('[data-uc-campo-busqueda]') : null;
    var botonesAbrirCajon = raiz.querySelectorAll('[data-uc-abrir-cajon]');
    var botonesCerrarCajon = raiz.querySelectorAll('[data-uc-cerrar-cajon]');
    var botonesBuscador = raiz.querySelectorAll('[data-uc-abrir-buscador]');
    var botonesCerrarBuscador = raiz.querySelectorAll('[data-uc-cerrar-buscador]');
    var acordeones = raiz.querySelectorAll('[data-uc-acordeon]');
    var anuncios = raiz.querySelector('[data-uc-anuncios]');
    var portal = null;
    var barraPortal = null;
    var buscadorPortal = null;
    var campoBusquedaPortal = null;
    var cerrarMegasRaiz = function () {};
    var cerrarMegasPortal = function () {};
    var fotogramaScroll = null;
    var cajonAbierto = false;
    var topInicialRaiz = raiz.getBoundingClientRect().top;

    function ajustarSuperposicion() {
      if (!envoltura) return;
      if (raiz.getAttribute('data-superponer') !== 'true') {
        envoltura.style.marginBottom = '';
        return;
      }
      envoltura.style.marginBottom = '-' + raiz.offsetHeight + 'px';
    }

    function abrirPanel(panel) {
      panel.style.setProperty('max-height', panel.scrollHeight + 'px', 'important');
    }

    function cerrarPanel(panel) {
      panel.style.setProperty('max-height', '0px', 'important');
    }

    function mostrarVelo(estado) {
      if (!velo) return;
      if (estado) {
        velo.hidden = false;
        requestAnimationFrame(function () {
          velo.classList.add('uc-cabecera__velo--visible');
        });
      } else {
        velo.classList.remove('uc-cabecera__velo--visible');
        window.setTimeout(function () {
          velo.hidden = true;
        }, 300);
      }
    }

    function actualizarBotonesCajon(estado) {
      botonesAbrirCajon.forEach(function (boton) {
        boton.setAttribute('aria-expanded', estado ? 'true' : 'false');
      });
      if (portal) {
        portal.querySelectorAll('[data-uc-abrir-cajon]').forEach(function (boton) {
          boton.setAttribute('aria-expanded', estado ? 'true' : 'false');
        });
      }
    }

    function abrirCajon() {
      if (!cajon) return;
      cajonAbierto = true;
      mostrarPortal(false);
      cajon.hidden = false;
      requestAnimationFrame(function () {
        cajon.classList.add('uc-cabecera__cajon--abierto');
      });
      mostrarVelo(true);
      document.documentElement.classList.add(CLASE_BLOQUEO);
      actualizarBotonesCajon(true);
    }

    function cerrarCajon() {
      if (!cajon) return;
      cajon.classList.remove('uc-cabecera__cajon--abierto');
      mostrarVelo(false);
      document.documentElement.classList.remove(CLASE_BLOQUEO);
      actualizarBotonesCajon(false);
      window.setTimeout(function () {
        if (!cajon.classList.contains('uc-cabecera__cajon--abierto')) {
          cajon.hidden = true;
          cajonAbierto = false;
          solicitarActualizarScroll();
        }
      }, 320);
    }

    function alternarBuscador(forzarCierre) {
      if (!buscador) return;
      var abierto = !buscador.hidden;
      if (abierto || forzarCierre === true) {
        buscador.hidden = true;
        botonesBuscador.forEach(function (boton) {
          boton.setAttribute('aria-expanded', 'false');
        });
      } else {
        buscador.hidden = false;
        botonesBuscador.forEach(function (boton) {
          boton.setAttribute('aria-expanded', 'true');
        });
        if (campoBusqueda) campoBusqueda.focus();
      }
    }

    function alternarBuscadorPortal(forzarCierre) {
      if (!buscadorPortal || !portal) return;
      var abierto = !buscadorPortal.hidden;
      var botones = portal.querySelectorAll('[data-uc-abrir-buscador]');
      if (abierto || forzarCierre === true) {
        buscadorPortal.hidden = true;
        botones.forEach(function (boton) {
          boton.setAttribute('aria-expanded', 'false');
        });
      } else {
        cerrarMegasPortal();
        buscadorPortal.hidden = false;
        botones.forEach(function (boton) {
          boton.setAttribute('aria-expanded', 'true');
        });
        if (campoBusquedaPortal) campoBusquedaPortal.focus();
      }
    }

    function conectarMegas(contenedor) {
      if (!contenedor) return function () {};
      var items = contenedor.querySelectorAll('[data-uc-item]');
      var temporizador = null;

      function cerrarTodos() {
        items.forEach(function (item) {
          item.classList.remove('uc-cabecera__item--abierto');
          var disparador = item.querySelector('[data-uc-disparador]');
          if (disparador) disparador.setAttribute('aria-expanded', 'false');
        });
      }

      function abrir(item) {
        cerrarTodos();
        item.classList.add('uc-cabecera__item--abierto');
        var disparador = item.querySelector('[data-uc-disparador]');
        if (disparador) disparador.setAttribute('aria-expanded', 'true');
      }

      items.forEach(function (item) {
        if (!item.querySelector('[data-uc-megamenu]')) return;

        item.addEventListener('mouseenter', function () {
          window.clearTimeout(temporizador);
          temporizador = window.setTimeout(function () {
            abrir(item);
          }, RETARDO_APERTURA);
        });

        item.addEventListener('mouseleave', function () {
          window.clearTimeout(temporizador);
          temporizador = window.setTimeout(cerrarTodos, RETARDO_CIERRE);
        });

        item.addEventListener('focusin', function () {
          window.clearTimeout(temporizador);
          abrir(item);
        });

        item.addEventListener('focusout', function (evento) {
          if (!item.contains(evento.relatedTarget)) cerrarTodos();
        });
      });

      return cerrarTodos;
    }

    function prepararClonBusqueda(clon, idPortal) {
      if (!clon) return;
      clon.querySelectorAll('[id]').forEach(function (elemento) {
        elemento.removeAttribute('id');
      });
      clon.id = 'uc-buscador-flotante-' + idPortal;
      clon.hidden = true;
    }

    function crearPortal() {
      if (!barra || raiz.classList.contains('uc-cabecera--estatica')) return;

      CONTADOR_PORTALES += 1;
      var idPortal = CONTADOR_PORTALES;
      portal = document.createElement('div');
      portal.className = raiz.className + ' uc-cabecera--portal-clon uc-cabecera--flotante';
      portal.setAttribute('style', raiz.getAttribute('style') || '');
      portal.setAttribute('aria-hidden', 'true');
      portal.setAttribute('data-uc-portal-clon', String(idPortal));

      barraPortal = barra.cloneNode(true);
      barraPortal.querySelectorAll('[id]').forEach(function (elemento) {
        elemento.removeAttribute('id');
      });
      portal.appendChild(barraPortal);

      if (buscador) {
        buscadorPortal = buscador.cloneNode(true);
        prepararClonBusqueda(buscadorPortal, idPortal);
        portal.appendChild(buscadorPortal);
        campoBusquedaPortal = buscadorPortal.querySelector('[data-uc-campo-busqueda]');
        barraPortal.querySelectorAll('[data-uc-abrir-buscador]').forEach(function (boton) {
          boton.setAttribute('aria-controls', buscadorPortal.id);
          boton.setAttribute('aria-expanded', 'false');
        });
      }

      document.body.appendChild(portal);
      raiz._ucPortal = portal;

      portal.querySelectorAll('[data-uc-abrir-cajon]').forEach(function (boton) {
        boton.addEventListener('click', abrirCajon);
      });

      portal.querySelectorAll('[data-uc-abrir-buscador]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          alternarBuscadorPortal();
        });
      });

      portal.querySelectorAll('[data-uc-cerrar-buscador]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          alternarBuscadorPortal(true);
        });
      });

      cerrarMegasPortal = conectarMegas(portal);
    }

    function mostrarPortal(estado) {
      if (!portal) return;
      if (estado) {
        portal.classList.add('uc-cabecera--portal-visible');
        portal.setAttribute('aria-hidden', 'false');
      } else {
        portal.classList.remove('uc-cabecera--portal-visible');
        portal.setAttribute('aria-hidden', 'true');
        alternarBuscadorPortal(true);
        cerrarMegasPortal();
      }
    }

    function obtenerDesplazamientoReal() {
      var porVentana = window.scrollY || window.pageYOffset || 0;
      var topActual = raiz.getBoundingClientRect().top;
      var porMovimientoVisual = Math.max(0, topInicialRaiz - topActual);
      return Math.max(porVentana, porMovimientoVisual);
    }

    function actualizarScroll() {
      fotogramaScroll = null;
      var referencia = anuncios ? anuncios.offsetHeight : 0;
      var umbral = parseInt(raiz.getAttribute('data-umbral'), 10);
      if (isNaN(umbral)) umbral = 40;
      var desplazamiento = obtenerDesplazamientoReal();

      if (desplazamiento > referencia) {
        raiz.classList.add('uc-cabecera--desplazada');
      } else {
        raiz.classList.remove('uc-cabecera--desplazada');
      }

      mostrarPortal(!cajonAbierto && desplazamiento > umbral);
    }

    function solicitarActualizarScroll() {
      if (fotogramaScroll !== null) return;
      fotogramaScroll = window.requestAnimationFrame(actualizarScroll);
    }

    botonesAbrirCajon.forEach(function (boton) {
      boton.addEventListener('click', abrirCajon);
    });

    botonesCerrarCajon.forEach(function (boton) {
      boton.addEventListener('click', cerrarCajon);
    });

    botonesBuscador.forEach(function (boton) {
      boton.addEventListener('click', function () {
        alternarBuscador();
      });
    });

    botonesCerrarBuscador.forEach(function (boton) {
      boton.addEventListener('click', function () {
        alternarBuscador(true);
      });
    });

    if (velo) {
      velo.addEventListener('click', cerrarCajon);
    }

    cerrarMegasRaiz = conectarMegas(raiz);
    crearPortal();

    acordeones.forEach(function (boton) {
      var panel = boton.nextElementSibling;
      if (!panel) return;

      cerrarPanel(panel);

      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        var abierto = boton.getAttribute('aria-expanded') === 'true';

        acordeones.forEach(function (otro) {
          if (otro === boton) return;
          var otroPanel = otro.nextElementSibling;
          otro.setAttribute('aria-expanded', 'false');
          if (otroPanel) cerrarPanel(otroPanel);
        });

        if (abierto) {
          boton.setAttribute('aria-expanded', 'false');
          cerrarPanel(panel);
        } else {
          boton.setAttribute('aria-expanded', 'true');
          abrirPanel(panel);
        }
      });
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      cerrarMegasRaiz();
      cerrarMegasPortal();
      alternarBuscador(true);
      alternarBuscadorPortal(true);
      if (cajon && cajon.classList.contains('uc-cabecera__cajon--abierto')) cerrarCajon();
    });

    window.addEventListener('scroll', solicitarActualizarScroll, { passive: true });
    document.addEventListener('scroll', solicitarActualizarScroll, true);

    window.addEventListener('resize', function () {
      if ((window.scrollY || window.pageYOffset || 0) <= 1 && !cajonAbierto) {
        topInicialRaiz = raiz.getBoundingClientRect().top;
      }
      ajustarSuperposicion();
      solicitarActualizarScroll();
      acordeones.forEach(function (boton) {
        if (boton.getAttribute('aria-expanded') !== 'true') return;
        var panel = boton.nextElementSibling;
        if (panel) abrirPanel(panel);
      });
    });

    ajustarSuperposicion();
    actualizarScroll();
    window.setTimeout(function () {
      ajustarSuperposicion();
      solicitarActualizarScroll();
    }, 400);

    if (anuncios) {
      var mensajes = anuncios.querySelectorAll('[data-uc-anuncio]');
      if (mensajes.length > 1) {
        var actual = 0;
        var velocidad = parseInt(anuncios.getAttribute('data-velocidad'), 10) || 4;
        window.setInterval(function () {
          mensajes[actual].classList.remove('uc-cabecera__anuncio--activo');
          actual = (actual + 1) % mensajes.length;
          mensajes[actual].classList.add('uc-cabecera__anuncio--activo');
        }, velocidad * 1000);
      }
    }
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var cabeceras = ambito.querySelectorAll('[data-uc-cabecera]');
    Array.prototype.forEach.call(cabeceras, iniciarCabecera);
  }

  function limpiarPortales(contexto) {
    if (!contexto) return;
    var cabeceras = contexto.querySelectorAll ? contexto.querySelectorAll('[data-uc-cabecera]') : [];
    Array.prototype.forEach.call(cabeceras, function (raiz) {
      if (raiz._ucPortal && raiz._ucPortal.parentNode) {
        raiz._ucPortal.parentNode.removeChild(raiz._ucPortal);
      }
      raiz._ucPortal = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    limpiarPortales(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-cajas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var pista = raiz.querySelector('[data-uc-pista]');
    var puntos = raiz.querySelector('[data-uc-puntos]');
    var piezas = raiz.querySelectorAll('[data-uc-pieza]');

    raiz.querySelectorAll('[data-uc-talla]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var forma = radio.closest('[data-uc-forma]');
        if (!forma) return;
        var boton = forma.querySelector('[data-uc-boton]');
        var texto = forma.querySelector('[data-uc-texto-boton]');
        if (!boton || !texto) return;
        var plantilla = boton.getAttribute('data-con-talla') || '';
        texto.textContent = plantilla
          .replace('{talla}', radio.getAttribute('data-talla') || '')
          .replace('{precio}', radio.getAttribute('data-precio') || '');
        var pieza = radio.closest('[data-uc-pieza]');
        if (pieza) pieza.classList.remove('uc-caja__pieza--pendiente');
      });
    });

    raiz.querySelectorAll('[data-uc-forma]').forEach(function (forma) {
      forma.addEventListener('submit', function (evento) {
        var boton = forma.querySelector('[data-uc-boton]');
        if (boton && boton.getAttribute('data-directo') === '1') return;
        if (forma.querySelector('[data-uc-talla]:checked')) return;

        evento.preventDefault();
        evento.stopPropagation();

        var pieza = forma.closest('[data-uc-pieza]');
        if (!pieza) return;
        pieza.classList.remove('uc-caja__pieza--pendiente');
        window.requestAnimationFrame(function () {
          pieza.classList.add('uc-caja__pieza--pendiente');
        });
      }, true);
    });

    if (!pista || !puntos || piezas.length < 2) return;

    piezas.forEach(function (pieza, indice) {
      var punto = document.createElement('button');
      punto.type = 'button';
      punto.className = 'uc-caja__punto' + (indice === 0 ? ' uc-caja__punto--activo' : '');
      punto.setAttribute('aria-label', 'Producto ' + (indice + 1));
      punto.addEventListener('click', function () {
        pista.scrollTo({ left: pieza.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      });
      puntos.appendChild(punto);
    });

    var marcas = puntos.querySelectorAll('.uc-caja__punto');

    pista.addEventListener('scroll', function () {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var activo = 0;
      var menor = Infinity;
      piezas.forEach(function (pieza, indice) {
        var medio = pieza.offsetLeft - pista.offsetLeft + pieza.offsetWidth / 2;
        var distancia = Math.abs(medio - centro);
        if (distancia < menor) {
          menor = distancia;
          activo = indice;
        }
      });
      marcas.forEach(function (marca, indice) {
        marca.classList.toggle('uc-caja__punto--activo', indice === activo);
      });
    }, { passive: true });
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-caja]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-carrupsel-pro-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_VISTOS = 'uc-vistos';

  function separarMiles(entero, separador) {
    return entero.replace(/\B(?=(\d{3})+(?!\d))/g, separador);
  }

  function formatearDinero(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var entero = partes[0];
    var decimales = partes[1];

    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (coincidencia, nombre) {
      if (nombre === 'amount_no_decimals') {
        return separarMiles(entero, ',');
      }
      if (nombre === 'amount_with_comma_separator') {
        return separarMiles(entero, '.') + ',' + decimales;
      }
      if (nombre === 'amount_no_decimals_with_comma_separator') {
        return separarMiles(entero, '.');
      }
      if (nombre === 'amount_with_apostrophe_separator') {
        return separarMiles(entero, "'") + '.' + decimales;
      }
      return separarMiles(entero, ',') + '.' + decimales;
    });
  }

  function leerVistos() {
    try {
      return JSON.parse(window.localStorage.getItem(CLAVE_VISTOS) || '[]');
    } catch (error) {
      return [];
    }
  }

  function registrarVisto(handle) {
    if (!handle) return;
    try {
      var guardados = leerVistos().filter(function (item) {
        return item !== handle;
      });
      guardados.unshift(handle);
      window.localStorage.setItem(CLAVE_VISTOS, JSON.stringify(guardados.slice(0, 20)));
    } catch (error) {
      return;
    }
  }

  function crearTarjeta(datos, opciones) {
    var enlace = document.createElement('a');
    enlace.className = 'uc-carrusel__tarjeta';
    enlace.setAttribute('data-uc-tarjeta', '');
    enlace.href = opciones.raiz + 'products/' + datos.handle;

    var caja = document.createElement('div');
    caja.className = 'uc-carrusel__imagen';

    if (datos.featured_image) {
      var imagen = document.createElement('img');
      imagen.src = datos.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_700x$1$2');
      imagen.alt = datos.title;
      imagen.loading = 'lazy';
      caja.appendChild(imagen);
    }

    if (opciones.mostrarEtiqueta && opciones.etiqueta) {
      var etiqueta = document.createElement('span');
      etiqueta.className = 'uc-carrusel__etiqueta';
      etiqueta.textContent = opciones.etiqueta;
      caja.appendChild(etiqueta);
    }

    enlace.appendChild(caja);

    if (opciones.mostrarMarca && datos.vendor) {
      var marca = document.createElement('span');
      marca.className = 'uc-carrusel__marca';
      marca.textContent = datos.vendor;
      enlace.appendChild(marca);
    }

    var nombre = document.createElement('span');
    nombre.className = 'uc-carrusel__nombre';
    nombre.textContent = datos.title;
    enlace.appendChild(nombre);

    var precios = document.createElement('span');
    precios.className = 'uc-carrusel__precios';

    var precio = document.createElement('span');
    precio.className = 'uc-carrusel__precio';
    precio.textContent = formatearDinero(datos.price, opciones.formato);
    precios.appendChild(precio);

    if (datos.compare_at_price && datos.compare_at_price > datos.price) {
      var antes = document.createElement('span');
      antes.className = 'uc-carrusel__precio-antes';
      antes.textContent = formatearDinero(datos.compare_at_price, opciones.formato);
      precios.appendChild(antes);
    }

    enlace.appendChild(precios);
    return enlace;
  }

  function cargarVistos(raiz, pista, vacio) {
    var handleActual = raiz.getAttribute('data-handle-actual');
    var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 8;
    var raizUrl = raiz.getAttribute('data-raiz-url') || '/';
    if (raizUrl.charAt(raizUrl.length - 1) !== '/') raizUrl = raizUrl + '/';

    var opciones = {
      raiz: raizUrl,
      formato: raiz.getAttribute('data-formato') || '${{amount_with_comma_separator}}',
      etiqueta: raiz.getAttribute('data-etiqueta'),
      mostrarEtiqueta: raiz.getAttribute('data-mostrar-etiqueta') === 'true',
      mostrarMarca: raiz.getAttribute('data-mostrar-marca') === 'true'
    };

    var handles = leerVistos().filter(function (handle) {
      return handle && handle !== handleActual;
    }).slice(0, limite);

    if (!handles.length) {
      raiz.classList.add('uc-carrusel--vacia');
      if (vacio) vacio.hidden = false;
      return;
    }

    var peticiones = handles.map(function (handle) {
      return fetch(raizUrl + 'products/' + handle + '.js')
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('sin producto');
          return respuesta.json();
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(peticiones).then(function (resultados) {
      var validos = resultados.filter(function (item) {
        return item && item.available !== false;
      });

      if (!validos.length) {
        raiz.classList.add('uc-carrusel--vacia');
        if (vacio) vacio.hidden = false;
        return;
      }

      validos.forEach(function (datos) {
        pista.appendChild(crearTarjeta(datos, opciones));
      });
    });
  }

  function iniciarCarrusel(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    registrarVisto(raiz.getAttribute('data-handle-actual'));

    var pista = raiz.querySelector('[data-uc-pista]');
    var vacio = raiz.querySelector('[data-uc-vacio]');
    var anterior = raiz.querySelector('[data-uc-anterior]');
    var siguiente = raiz.querySelector('[data-uc-siguiente]');
    if (!pista) return;

    if (raiz.getAttribute('data-origen') === 'vistos') {
      cargarVistos(raiz, pista, vacio);
    } else if (!pista.querySelector('[data-uc-tarjeta]')) {
      raiz.classList.add('uc-carrusel--vacia');
    }

    function paso() {
      var tarjeta = pista.querySelector('[data-uc-tarjeta]');
      if (!tarjeta) return pista.clientWidth;
      return tarjeta.getBoundingClientRect().width + 16;
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: 'smooth' });
      });
    }
  }

  function iniciarTodos(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-carrusel]');
    Array.prototype.forEach.call(nodos, iniciarCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-colecciones-filtros"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var form = raiz.querySelector('[data-coluc-form]');
    var panel = raiz.querySelector('[data-coluc-panel]');
    var overlay = raiz.querySelector('[data-coluc-overlay]');
    var abrir = raiz.querySelector('[data-coluc-abrir]');
    var cerrar = raiz.querySelector('[data-coluc-cerrar]');
    if (!form) return;

    function esEscritorio() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function abrirPanel() {
      if (panel) panel.classList.add('coluc-activo');
      if (overlay) overlay.classList.add('coluc-activo');
      document.body.style.overflow = 'hidden';
    }
    function cerrarPanel() {
      if (panel) panel.classList.remove('coluc-activo');
      if (overlay) overlay.classList.remove('coluc-activo');
      document.body.style.overflow = '';
    }
    if (abrir) abrir.addEventListener('click', abrirPanel);
    if (cerrar) cerrar.addEventListener('click', cerrarPanel);
    if (overlay) overlay.addEventListener('click', cerrarPanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarPanel();
    });

    var sort = raiz.querySelector('[data-coluc-sort]');
    if (sort) {
      sort.addEventListener('change', function () { form.submit(); });
    }

    // En escritorio, cualquier checkbox se aplica de inmediato.
    // En movil, la marca/proveedor tambien debe aplicarse de inmediato porque
    // el filtro Modelo depende del resultado que Shopify devuelve tras recargar.
    raiz.querySelectorAll('[data-coluc-check]').forEach(function (chk) {
      chk.addEventListener('change', function () {
        if (esEscritorio()) {
          form.submit();
          return;
        }

        if (chk.name === 'filter.p.vendor') {
          try {
            sessionStorage.setItem('coluc-reabrir-filtros', '1');
          } catch (e) {}
          form.submit();
        }
      });
    });

    // Tras recargar por un cambio de Marca en movil, vuelve a abrir el panel
    // para que el cliente vea inmediatamente el filtro Modelo actualizado.
    if (!esEscritorio()) {
      try {
        if (sessionStorage.getItem('coluc-reabrir-filtros') === '1') {
          sessionStorage.removeItem('coluc-reabrir-filtros');
          window.setTimeout(abrirPanel, 50);
        }
      } catch (e) {}
    }

    raiz.querySelectorAll('[data-coluc-precio]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (esEscritorio()) form.submit();
      });
    });

    raiz.querySelectorAll('[data-coluc-vermas]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cont = btn.closest('[data-coluc-opciones]');
        if (cont) cont.classList.add('coluc-todos');
      });
    });
  }

  document.querySelectorAll('[data-coluc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-coluc-listo')) return;
    raiz.setAttribute('data-coluc-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-halloween"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(capa) {
    if (capa.dataset.murInit === 'true') { return; }
    capa.dataset.murInit = 'true';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var chico = window.matchMedia('(max-width: 748px)');
    var todos = Array.prototype.slice.call(capa.querySelectorAll('[data-murci]'));
    if (!todos.length) { return; }

    if (capa.getAttribute('data-ocultar-movil') === 'true' && chico.matches) {
      capa.style.setProperty('display', 'none', 'important');
      return;
    }

    var maxMovil = parseInt(capa.getAttribute('data-cantidad-movil'), 10) || todos.length;
    var activos = chico.matches ? todos.slice(0, maxMovil) : todos;
    todos.forEach(function (el) {
      if (activos.indexOf(el) === -1) { el.style.setProperty('display', 'none', 'important'); }
    });

    var base = parseFloat(capa.getAttribute('data-velocidad')) || 26;
    var espantar = capa.getAttribute('data-espantar') === 'true';
    var radio = parseFloat(capa.getAttribute('data-radio-espanto')) || 140;

    var W = window.innerWidth;
    var H = window.innerHeight;
    var raton = { x: -9999, y: -9999, vivo: false };

    var bichos = activos.map(function (el, i) {
      var px = parseFloat(el.getAttribute('data-x')) || 50;
      var py = parseFloat(el.getAttribute('data-y')) || 50;
      var esc = (parseFloat(el.getAttribute('data-escala')) || 10) / 10;
      var ang = (i * 47) % 360 * Math.PI / 180;
      var vel = base * (0.7 + ((i * 29) % 60) / 100);
      return {
        el: el,
        cuerpo: el.querySelector('.murci-cuerpo'),
        x: (px / 100) * W,
        y: (py / 100) * H,
        vx: Math.cos(ang) * vel,
        vy: Math.sin(ang) * vel * 0.45,
        esc: esc,
        fase: (i * 1.7) % 6.28,
        ancho: 40,
        alto: 26,
        dir: 1,
        asustado: false
      };
    });

    function medir() {
      W = window.innerWidth;
      H = window.innerHeight;
      bichos.forEach(function (b) {
        var r = b.el.getBoundingClientRect();
        if (r.width) { b.ancho = r.width; b.alto = r.height; }
      });
    }

    window.addEventListener('resize', medir);

    if (espantar) {
      window.addEventListener('mousemove', function (e) {
        raton.x = e.clientX; raton.y = e.clientY; raton.vivo = true;
      }, { passive: true });
      window.addEventListener('mouseout', function () { raton.vivo = false; });
    }

    var previo = 0;
    var corriendo = true;

    function paso(t) {
      if (!corriendo) { return; }
      if (!previo) { previo = t; }
      var dt = Math.min((t - previo) / 1000, 0.05);
      previo = t;

      for (var i = 0; i < bichos.length; i++) {
        var b = bichos[i];
        b.fase += dt * 1.6;

        b.vy += Math.sin(b.fase) * 14 * dt;

        if (espantar && raton.vivo) {
          var dx = b.x + b.ancho / 2 - raton.x;
          var dy = b.y + b.alto / 2 - raton.y;
          var d2 = dx * dx + dy * dy;
          if (d2 < radio * radio && d2 > 1) {
            var d = Math.sqrt(d2);
            if (!b.asustado) {
              b.asustado = true;
              b.vx += (dx / d) * base * 4.2;
              b.vy += (dy / d) * base * 4.2 - base * 0.8;
            }
            var fuerza = (1 - d / radio) * 1500;
            b.vx += (dx / d) * fuerza * dt;
            b.vy += (dy / d) * fuerza * dt;
          } else if (d2 > radio * radio * 2.3) {
            b.asustado = false;
          }
        }

        var rapidez = Math.sqrt(b.vx * b.vx + b.vy * b.vy);
        var tope = base * 5.5;
        if (rapidez > tope) { b.vx = b.vx / rapidez * tope; b.vy = b.vy / rapidez * tope; }
        if (rapidez < base * 0.45) {
          var f = (base * 0.45) / (rapidez || 1);
          b.vx *= f; b.vy *= f;
        }

        b.x += b.vx * dt;
        b.y += b.vy * dt;

        if (b.x < -b.ancho) { b.x = W + b.ancho; }
        if (b.x > W + b.ancho) { b.x = -b.ancho; }
        if (b.y < 0) { b.y = 0; b.vy = Math.abs(b.vy); }
        if (b.y > H - b.alto) { b.y = H - b.alto; b.vy = -Math.abs(b.vy); }

        var nuevaDir = b.vx >= 0 ? 1 : -1;
        if (nuevaDir !== b.dir) { b.dir = nuevaDir; }

        var inclina = Math.max(-18, Math.min(18, b.vy * 0.35));
        b.el.style.setProperty('transform', 'translate3d(' + Math.round(b.x) + 'px,' + Math.round(b.y) + 'px,0)', 'important');
        if (b.cuerpo) {
          b.cuerpo.style.setProperty('transform', 'scaleX(' + (b.dir * b.esc) + ') scaleY(' + b.esc + ') rotate(' + (inclina * b.dir) + 'deg)', 'important');
        }
      }
      window.requestAnimationFrame(paso);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { corriendo = false; }
      else if (!corriendo) { corriendo = true; previo = 0; window.requestAnimationFrame(paso); }
    });

    medir();
    bichos.forEach(function (b, i) {
      setTimeout(function () { b.el.classList.add('esta-visible'); }, i * 180);
    });

    if (reduce.matches) {
      bichos.forEach(function (b) {
        b.el.style.setProperty('transform', 'translate3d(' + Math.round(b.x) + 'px,' + Math.round(b.y) + 'px,0)', 'important');
      });
      return;
    }

    window.requestAnimationFrame(paso);
  }

  function todo() { document.querySelectorAll('[data-murcielagos]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-landing-creativos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function separarMiles(entero, separador) {
    return entero.replace(/\B(?=(\d{3})+(?!\d))/g, separador);
  }

  function formatearDinero(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var entero = partes[0];
    var decimales = partes[1];

    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (coincidencia, nombre) {
      if (nombre === 'amount_no_decimals') return separarMiles(entero, ',');
      if (nombre === 'amount_with_comma_separator') return separarMiles(entero, '.') + ',' + decimales;
      if (nombre === 'amount_no_decimals_with_comma_separator') return separarMiles(entero, '.');
      return separarMiles(entero, ',') + '.' + decimales;
    });
  }

  function iniciarLanding(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var formato = raiz.getAttribute('data-formato') || '${{amount_with_comma_separator}}';
    var descuento = parseInt(raiz.getAttribute('data-descuento'), 10) || 0;
    var codigo = (raiz.getAttribute('data-codigo') || '').trim();
    var rutaAgregar = raiz.getAttribute('data-ruta-agregar') || '/cart/add';
    var rutaCarrito = raiz.getAttribute('data-ruta-carrito') || '/cart';

    var precios = raiz.querySelectorAll('[data-uc-precio]');
    var etiquetas = raiz.querySelectorAll('[data-uc-elegida]');
    var textoBoton = raiz.querySelector('[data-uc-texto-boton]');
    var botonComprar = raiz.querySelector('[data-uc-comprar]');
    var botonAgregar = raiz.querySelector('[data-uc-agregar]');
    var barra = raiz.querySelector('[data-uc-barra]');
    var barraBoton = raiz.querySelector('[data-uc-barra-comprar]');
    var aviso = raiz.querySelector('[data-uc-aviso]');
    var adicional = raiz.querySelector('[data-uc-adicional]');
    var casillaSegundo = raiz.querySelector('[data-uc-segundo]');
    var zonaSegunda = raiz.querySelector('[data-uc-zona-talla-dos]');
    var zonaTalla = raiz.querySelector('[data-uc-zona-talla]');
    var modal = raiz.querySelector('[data-uc-modal]');
    var acordeones = raiz.querySelectorAll('[data-uc-acordeon]');
    var pista = raiz.querySelector('[data-uc-pista]');

    function tallaDe(par) {
      return raiz.querySelector('[data-uc-talla][data-par="' + par + '"]:checked');
    }

    function precioBase() {
      var primera = raiz.querySelector('[data-uc-talla]');
      return primera ? parseInt(primera.getAttribute('data-precio'), 10) : 0;
    }

    function precioDe(par) {
      var elegida = tallaDe(par);
      return elegida ? parseInt(elegida.getAttribute('data-precio'), 10) : precioBase();
    }

    function quiereSegundo() {
      return !!(casillaSegundo && casillaSegundo.checked);
    }

    function refrescar() {
      etiquetas.forEach(function (nodo) {
        var par = parseInt(nodo.getAttribute('data-par'), 10);
        var elegida = tallaDe(par);
        nodo.textContent = elegida ? elegida.getAttribute('data-talla') : '';
      });

      if (adicional) adicional.classList.toggle('uc-par__adicional--activo', quiereSegundo());
      if (zonaSegunda) zonaSegunda.hidden = !quiereSegundo();

      var total = precioDe(1);
      if (quiereSegundo()) total = total + precioDe(2) - descuento;
      if (total < 0) total = 0;

      precios.forEach(function (nodo) {
        nodo.textContent = formatearDinero(total, formato);
      });

      if (textoBoton) {
        textoBoton.textContent = textoBoton.getAttribute('data-plantilla').replace('{total}', formatearDinero(total, formato));
      }
    }

    function pedirTalla(par) {
      var zona = par === 2 ? zonaSegunda : zonaTalla;
      if (zona) zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (aviso) {
        aviso.hidden = false;
        window.setTimeout(function () {
          aviso.hidden = true;
        }, 4000);
      }
    }

    function enviar(irAlPago) {
      if (!tallaDe(1)) {
        pedirTalla(1);
        return;
      }
      if (quiereSegundo() && !tallaDe(2)) {
        pedirTalla(2);
        return;
      }

      var articulos = [{ id: parseInt(tallaDe(1).value, 10), quantity: 1 }];
      if (quiereSegundo()) articulos.push({ id: parseInt(tallaDe(2).value, 10), quantity: 1 });

      if (botonComprar) botonComprar.disabled = true;
      if (botonAgregar) botonAgregar.disabled = true;

      fetch(rutaAgregar + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: articulos })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('sin stock');
          return respuesta.json();
        })
        .then(function () {
          if (!irAlPago) {
            window.location.href = rutaCarrito;
            return;
          }
          if (quiereSegundo() && codigo) {
            window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/checkout';
          } else {
            window.location.href = '/checkout';
          }
        })
        .catch(function () {
          if (botonComprar) botonComprar.disabled = false;
          if (botonAgregar) botonAgregar.disabled = false;
          window.location.href = rutaCarrito;
        });
    }

    raiz.querySelectorAll('[data-uc-talla]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (aviso) aviso.hidden = true;
        refrescar();
      });
    });

    if (casillaSegundo) {
      casillaSegundo.addEventListener('change', refrescar);
    }

    if (botonComprar) {
      botonComprar.addEventListener('click', function () {
        enviar(true);
      });
    }

    if (botonAgregar) {
      botonAgregar.addEventListener('click', function () {
        enviar(false);
      });
    }

    if (barraBoton) {
      barraBoton.addEventListener('click', function () {
        enviar(true);
      });
    }

    if (pista) {
      var laminas = raiz.querySelectorAll('[data-uc-lamina]');
      var miniaturas = raiz.querySelectorAll('[data-uc-miniatura]');

      miniaturas.forEach(function (miniatura) {
        miniatura.addEventListener('click', function () {
          var indice = parseInt(miniatura.getAttribute('data-indice'), 10);
          if (!laminas[indice]) return;
          pista.scrollTo({ left: laminas[indice].offsetLeft, behavior: 'smooth' });
        });
      });

      pista.addEventListener('scroll', function () {
        if (!pista.clientWidth) return;
        var indice = Math.round(pista.scrollLeft / pista.clientWidth);
        miniaturas.forEach(function (otra, posicion) {
          otra.classList.toggle('uc-par__miniatura--activa', posicion === indice);
        });
      }, { passive: true });
    }

    acordeones.forEach(function (boton) {
      var panel = boton.nextElementSibling;
      if (!panel) return;
      panel.style.setProperty('max-height', '0px', 'important');
      boton.addEventListener('click', function () {
        var abierto = boton.getAttribute('aria-expanded') === 'true';
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        panel.style.setProperty('max-height', abierto ? '0px' : panel.scrollHeight + 'px', 'important');
      });
    });

    raiz.querySelectorAll('[data-uc-abrir-guia]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (modal) modal.hidden = false;
      });
    });

    raiz.querySelectorAll('[data-uc-cerrar-guia]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (modal) modal.hidden = true;
      });
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && modal) modal.hidden = true;
    });

    if (barra && botonComprar && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          barra.classList.toggle('uc-par__barra--visible', !entrada.isIntersecting);
        });
      }, { threshold: 0 });
      observador.observe(botonComprar);
    }

    refrescar();
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-par-landing]');
    Array.prototype.forEach.call(nodos, iniciarLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var track = raiz.querySelector('[data-nu-track]');
    if (!track) return;
    var prev = raiz.querySelector('[data-nu-prev]');
    var next = raiz.querySelector('[data-nu-next]');

    function paso() {
      var card = track.querySelector('.nuevos-uc__card');
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 16;
      var ancho = card.getBoundingClientRect().width + gap;
      var visibles = Math.max(1, Math.floor(track.clientWidth / ancho));
      return ancho * visibles;
    }

    function actualizar() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); }, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  document.querySelectorAll('[data-nuevos-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-nu-listo')) return;
    raiz.setAttribute('data-nu-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-pag-futbol-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFutbol(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var pestanas = raiz.querySelectorAll('[data-uc-pestana]');
    var paneles = raiz.querySelectorAll('[data-uc-panel]');
    if (!pestanas.length) return;

    function activar(indice) {
      pestanas.forEach(function (pestana) {
        var suyo = parseInt(pestana.getAttribute('data-indice'), 10) === indice;
        pestana.classList.toggle('uc-futbol__pestana--activa', suyo);
        pestana.setAttribute('aria-selected', suyo ? 'true' : 'false');
      });

      paneles.forEach(function (panel) {
        panel.hidden = parseInt(panel.getAttribute('data-indice'), 10) !== indice;
      });
    }

    pestanas.forEach(function (pestana) {
      pestana.addEventListener('click', function () {
        activar(parseInt(pestana.getAttribute('data-indice'), 10));
      });

      pestana.addEventListener('keydown', function (evento) {
        if (evento.key !== 'ArrowRight' && evento.key !== 'ArrowLeft') return;
        evento.preventDefault();
        var actual = parseInt(pestana.getAttribute('data-indice'), 10);
        var paso = evento.key === 'ArrowRight' ? 1 : -1;
        var siguiente = (actual + paso + pestanas.length) % pestanas.length;
        activar(siguiente);
        pestanas[siguiente].focus();
      });
    });

    raiz.addEventListener('uc-abrir-pestana', function (evento) {
      activar(evento.detail);
    });
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-futbol]');
    Array.prototype.forEach.call(nodos, iniciarFutbol);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });

  document.addEventListener('shopify:block:select', function (evento) {
    var pestana = evento.target.querySelector
      ? evento.target.querySelector('[data-uc-pestana]')
      : null;
    var destino = pestana || evento.target;
    if (!destino || !destino.getAttribute) return;
    var indice = destino.getAttribute('data-indice');
    if (indice === null) return;
    var raiz = destino.closest('[data-uc-futbol]');
    if (!raiz) return;
    raiz.dispatchEvent(new CustomEvent('uc-abrir-pestana', { detail: parseInt(indice, 10) }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-pag-mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarVendidos(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var lista = raiz.querySelector('[data-uc-lista]');
    var anterior = raiz.querySelector('[data-uc-anterior]');
    var siguiente = raiz.querySelector('[data-uc-siguiente]');
    if (!lista) return;

    function esCarrusel() {
      return window.getComputedStyle(lista).overflowX !== 'visible';
    }

    function paso() {
      var tarjeta = lista.querySelector('[data-uc-tarjeta]');
      if (!tarjeta) return lista.clientWidth;
      var estilo = window.getComputedStyle(lista);
      var separacion = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return tarjeta.getBoundingClientRect().width + separacion;
    }

    function mover(direccion) {
      if (esCarrusel()) {
        lista.scrollBy({ left: direccion * paso(), behavior: 'smooth' });
        return;
      }
      var destino = direccion > 0 ? lista.scrollHeight : 0;
      lista.scrollTo({ top: destino, behavior: 'smooth' });
    }

    function actualizarFlechas() {
      if (!anterior || !siguiente) return;
      if (!esCarrusel()) {
        anterior.hidden = true;
        siguiente.hidden = true;
        return;
      }
      anterior.hidden = false;
      siguiente.hidden = false;
      anterior.disabled = lista.scrollLeft <= 2;
      siguiente.disabled = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 2;
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        mover(-1);
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        mover(1);
      });
    }

    lista.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-vendidos]');
    Array.prototype.forEach.call(nodos, iniciarVendidos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-popup-10"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE = 'uc_oferta_estado';
  var DIA = 86400000;

  function leer() {
    try { return JSON.parse(window.localStorage.getItem(CLAVE)) || {}; } catch (e) { return {}; }
  }

  function guardar(cambios) {
    var estado = leer();
    for (var k in cambios) {
      if (Object.prototype.hasOwnProperty.call(cambios, k)) estado[k] = cambios[k];
    }
    try { window.localStorage.setItem(CLAVE, JSON.stringify(estado)); } catch (e) {}
    return estado;
  }

  function vigente(fecha, dias) {
    if (!fecha) return false;
    if (dias <= 0) return true;
    return Date.now() - fecha < dias * DIA;
  }

  function numero(raiz, nombre, porDefecto) {
    var valor = parseFloat(raiz.getAttribute(nombre));
    return isNaN(valor) ? porDefecto : valor;
  }

  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var esMovil = window.matchMedia('(max-width: 748px)').matches;
    if (esMovil && raiz.getAttribute('data-mostrar-movil') !== '1') return;
    if (!esMovil && raiz.getAttribute('data-mostrar-escritorio') !== '1') return;

    if (raiz.parentNode !== document.body) document.body.appendChild(raiz);

    var escena = raiz.querySelector('[data-uc-oferta-escena]');
    var burbuja = raiz.querySelector('[data-uc-oferta-burbuja]');
    var forma = raiz.querySelector('.uc-oferta__forma');
    var campo = raiz.querySelector('#uc-oferta-correo');
    var enviar = raiz.querySelector('[data-uc-oferta-enviar]');
    var error = raiz.querySelector('[data-uc-oferta-error]');
    var pasoCorreo = raiz.querySelector('[data-uc-oferta-paso="correo"]');
    var pasoCodigo = raiz.querySelector('[data-uc-oferta-paso="codigo"]');
    var copiar = raiz.querySelector('[data-uc-oferta-copiar]');
    var copiarTexto = raiz.querySelector('[data-uc-oferta-copiar-texto]');

    var retraso = numero(raiz, 'data-retraso', 6) * 1000;
    var diasPopup = numero(raiz, 'data-dias', 7);
    var diasBurbuja = numero(raiz, 'data-dias-burbuja', 3);
    var codigo = raiz.getAttribute('data-codigo') || '';
    var textoCopiar = raiz.getAttribute('data-texto-copiar') || '';
    var textoCopiado = raiz.getAttribute('data-texto-copiado') || '';
    var textoEnviando = raiz.getAttribute('data-texto-enviando') || '...';
    var enfoqueAnterior = null;
    var abierto = false;

    function mostrarPaso(nombre) {
      var cual = nombre === 'codigo' ? pasoCodigo : pasoCorreo;
      var otro = nombre === 'codigo' ? pasoCorreo : pasoCodigo;
      if (otro) otro.hidden = true;
      if (!cual) return;
      cual.hidden = false;
      cual.classList.remove('uc-oferta__paso--entrando');
      void cual.offsetWidth;
      cual.classList.add('uc-oferta__paso--entrando');
    }

    function burbujaPermitida() {
      var estado = leer();
      if (estado.suscrito) return false;
      return !vigente(estado.burbujaQuitada, diasBurbuja);
    }

    function pintarBurbuja() {
      if (!burbuja) return;
      burbuja.hidden = abierto || !burbujaPermitida();
    }

    function abrir() {
      if (!escena || abierto) return;
      abierto = true;
      enfoqueAnterior = document.activeElement;
      mostrarPaso(leer().suscrito ? 'codigo' : 'correo');
      escena.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      pintarBurbuja();
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          raiz.classList.add('uc-oferta--visible');
        });
      });
      window.setTimeout(function () {
        if (!leer().suscrito && campo && !esMovil) campo.focus();
      }, 380);
    }

    function cerrar() {
      if (!abierto) return;
      abierto = false;
      raiz.classList.remove('uc-oferta--visible');
      document.documentElement.style.overflow = '';
      if (!leer().suscrito) guardar({ cerrado: Date.now() });
      window.setTimeout(function () {
        if (!abierto && escena) escena.hidden = true;
        pintarBurbuja();
      }, 420);
      if (enfoqueAnterior && enfoqueAnterior.focus) {
        try { enfoqueAnterior.focus(); } catch (e) {}
      }
    }

    raiz.querySelectorAll('[data-uc-oferta-cerrar]').forEach(function (nodo) {
      nodo.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        cerrar();
      });
    });

    var abrirBurbuja = raiz.querySelector('[data-uc-oferta-abrir]');
    if (abrirBurbuja) {
      abrirBurbuja.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        abrir();
      });
    }

    var quitarBurbuja = raiz.querySelector('[data-uc-oferta-quitar]');
    if (quitarBurbuja) {
      quitarBurbuja.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        guardar({ burbujaQuitada: Date.now() });
        if (burbuja) burbuja.hidden = true;
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && abierto) cerrar();
    });

    if (forma) {
      forma.addEventListener('submit', function (evento) {
        evento.preventDefault();
        evento.stopImmediatePropagation();

        if (!forma.checkValidity()) {
          forma.reportValidity();
          return;
        }

        if (error) error.hidden = true;
        var original = enviar ? enviar.textContent : '';
        if (enviar) {
          enviar.disabled = true;
          enviar.textContent = textoEnviando;
        }

        function restaurar() {
          if (!enviar) return;
          enviar.disabled = false;
          enviar.textContent = original;
        }

        var control = typeof AbortController === 'function' ? new AbortController() : null;
        var reloj = window.setTimeout(function () { if (control) control.abort(); }, 9000);

        fetch(forma.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(forma),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: control ? control.signal : undefined
        })
          .then(function (respuesta) {
            window.clearTimeout(reloj);
            restaurar();
            if (respuesta.status >= 500) throw new Error('servidor');
            guardar({ suscrito: Date.now() });
            mostrarPaso('codigo');
            pintarBurbuja();
          })
          .catch(function () {
            window.clearTimeout(reloj);
            restaurar();
            if (error) error.hidden = false;
          });
      }, true);
    }

    if (copiar) {
      copiar.addEventListener('click', function () {
        function avisar() {
          if (!copiarTexto) return;
          copiarTexto.textContent = textoCopiado;
          window.setTimeout(function () { copiarTexto.textContent = textoCopiar; }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(avisar, avisar);
          return;
        }
        var auxiliar = document.createElement('textarea');
        auxiliar.value = codigo;
        auxiliar.setAttribute('readonly', '');
        auxiliar.style.position = 'fixed';
        auxiliar.style.opacity = '0';
        document.body.appendChild(auxiliar);
        auxiliar.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(auxiliar);
        avisar();
      });
    }

    var estado = leer();
    pintarBurbuja();

    if (!estado.suscrito && !vigente(estado.cerrado, diasPopup)) {
      window.setTimeout(function () {
        if (!abierto && !leer().suscrito) abrir();
      }, retraso);
    }
  }

  function iniciarTodos(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-oferta]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-producto-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_VISTOS = 'uc-vistos';

  function lista(nodos) {
    return Array.prototype.slice.call(nodos || []);
  }

  function leerJSON(nodo) {
    try {
      return JSON.parse(nodo ? nodo.textContent : '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function escapar(texto) {
    return String(texto == null ? '' : texto)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function conAncho(url, ancho) {
    if (!url) return '';
    if (url.indexOf('data:') === 0) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }

  var ESCRITORIO = '(min-width: 990px)';

  function esEscritorio() {
    return window.matchMedia(ESCRITORIO).matches;
  }

  function arrastrar(zona, pista, acciones) {
    var activo = false;
    var movido = false;
    var inicioX = 0;
    var inicioY = 0;
    var delta = 0;

    zona.addEventListener('pointerdown', function (e) {
      if (!esEscritorio()) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      activo = true;
      movido = false;
      delta = 0;
      inicioX = e.clientX;
      inicioY = e.clientY;
    });

    zona.addEventListener('pointermove', function (e) {
      if (!activo) return;
      delta = e.clientX - inicioX;
      if (!movido) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(e.clientY - inicioY) > Math.abs(delta)) {
          activo = false;
          return;
        }
        movido = true;
        pista.classList.add('uc-ficha__arrastrando');
        try { zona.setPointerCapture(e.pointerId); } catch (x) {}
      }
      e.preventDefault();
      acciones.mover(delta);
    });

    function soltar() {
      if (!activo) return;
      activo = false;
      pista.classList.remove('uc-ficha__arrastrando');
      if (movido) acciones.soltar(delta);
    }

    zona.addEventListener('pointerup', soltar);
    zona.addEventListener('pointercancel', soltar);
    zona.addEventListener('lostpointercapture', soltar);
    zona.addEventListener('click', function (e) {
      if (!movido) return;
      movido = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    zona.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function decodificar(texto) {
    var auxiliar = document.createElement('textarea');
    auxiliar.innerHTML = texto || '';
    return auxiliar.value;
  }

  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var variantes = leerJSON(raiz.querySelector('[data-uc-variantes]'));
    var formulario = raiz.querySelector('.uc-ficha__formulario');
    var campoId = raiz.querySelector('[data-uc-id-variante]');
    var radios = lista(raiz.querySelectorAll('[data-uc-radio]'));
    var zona = raiz.querySelector('[data-uc-zona-selector]');
    var errorNodo = raiz.querySelector('[data-uc-error]');
    var botonAgregar = raiz.querySelector('[data-uc-boton-agregar]');
    var textoBoton = raiz.querySelector('[data-uc-texto-boton]');
    var precio = raiz.querySelector('[data-uc-precio]');
    var precioAntes = raiz.querySelector('[data-uc-precio-antes]');
    var sku = raiz.querySelector('[data-uc-sku]');
    var skuFila = raiz.querySelector('[data-uc-sku-fila]');
    var totalOpciones = raiz.querySelectorAll('[data-uc-opcion]').length;
    var textoSinTalla = errorNodo ? errorNodo.textContent.trim() : '';
    var textoAgotada = errorNodo ? (decodificar(errorNodo.getAttribute('data-texto-agotada')) || textoSinTalla) : '';
    var textoDisponible = botonAgregar ? decodificar(botonAgregar.getAttribute('data-texto-disponible')) : '';
    var textoAgotado = botonAgregar ? decodificar(botonAgregar.getAttribute('data-texto-agotado')) : '';
    var algunoDisponible = variantes.some(function (v) { return v.disponible; });

    function seleccionActual() {
      var seleccion = [];
      for (var i = 0; i < totalOpciones; i++) {
        var marcado = raiz.querySelector('[data-uc-radio][data-indice="' + i + '"]:checked');
        seleccion.push(marcado ? marcado.value : null);
      }
      return seleccion;
    }

    function buscarVariante(seleccion) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var igual = v.opciones.every(function (valor, j) { return valor === seleccion[j]; });
        if (igual) return v;
      }
      return null;
    }

    function estado() {
      if (totalOpciones === 0) return { completa: true, variante: variantes[0] || null };
      var seleccion = seleccionActual();
      var completa = seleccion.every(function (v) { return v !== null; });
      return { completa: completa, variante: completa ? buscarVariante(seleccion) : null, seleccion: seleccion };
    }

    function hayDisponible(indice, valor, seleccion) {
      return variantes.some(function (v) {
        if (v.opciones[indice] !== valor || !v.disponible) return false;
        return v.opciones.every(function (opcion, i) {
          return i === indice || seleccion[i] === null || opcion === seleccion[i];
        });
      });
    }

    function marcarAgotados(seleccion) {
      radios.forEach(function (radio) {
        var etiqueta = radio.closest('.uc-ficha__valor');
        if (!etiqueta) return;
        var indice = parseInt(radio.getAttribute('data-indice'), 10);
        etiqueta.classList.toggle('uc-ficha__valor--agotado', !hayDisponible(indice, radio.value, seleccion));
      });
    }

    var subBoton = raiz.querySelector('[data-uc-sub-boton]');

    function pintarBoton(disponible) {
      if (subBoton) subBoton.hidden = !disponible;
      if (!botonAgregar) return;
      botonAgregar.disabled = !disponible;
      if (textoBoton) textoBoton.textContent = disponible ? textoDisponible : textoAgotado;
    }

    function ocultarError() {
      if (errorNodo) errorNodo.hidden = true;
      if (zona) zona.classList.remove('uc-ficha__selector--alerta');
    }

    function mostrarError(texto) {
      if (errorNodo) {
        errorNodo.textContent = texto;
        errorNodo.hidden = false;
      }
      if (!zona) return;
      zona.classList.remove('uc-ficha__selector--alerta');
      void zona.offsetWidth;
      zona.classList.add('uc-ficha__selector--alerta');
      var caja = zona.getBoundingClientRect();
      if (caja.top < 80 || caja.bottom > window.innerHeight) {
        zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function actualizarUrl(id) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    }

    function actualizar(moverGaleria) {
      var e = estado();
      if (e.seleccion) marcarAgotados(e.seleccion);
      ocultarError();

      if (!e.completa || !e.variante) {
        if (campoId) campoId.disabled = true;
        pintarBoton(algunoDisponible);
        return;
      }

      var v = e.variante;
      if (campoId) {
        var cambio = String(campoId.value) !== String(v.id) || campoId.disabled;
        campoId.value = v.id;
        campoId.disabled = false;
        if (cambio) campoId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (precio) precio.textContent = v.precio;
      if (precioAntes) {
        precioAntes.textContent = v.antes || '';
        precioAntes.hidden = !v.antes;
      }
      if (sku) sku.textContent = v.sku || '';
      if (skuFila) skuFila.hidden = !v.sku;
      pintarBoton(v.disponible);
      if (totalOpciones > 0) actualizarUrl(v.id);
      if (moverGaleria && v.media) irAMedia(v.media);
    }

    function validar() {
      var e = estado();
      if (!e.completa || !e.variante) {
        mostrarError(textoSinTalla);
        return false;
      }
      if (!e.variante.disponible) {
        mostrarError(textoAgotada);
        return false;
      }
      return true;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { actualizar(true); });
    });

    if (botonAgregar) {
      botonAgregar.addEventListener('click', function (evento) {
        if (!validar()) {
          evento.preventDefault();
          evento.stopImmediatePropagation();
        }
      });
    }

    if (formulario) {
      window.addEventListener('submit', function (evento) {
        if (evento.target !== formulario) return;
        if (!validar() || !campoId || campoId.disabled || !campoId.value) {
          evento.preventDefault();
          evento.stopImmediatePropagation();
        }
      }, true);
    }

    window.addEventListener('click', function (evento) {
      var objetivo = evento.target;
      if (!objetivo || !objetivo.closest) return;
      var cod = objetivo.closest('#es-popup-button, .es-popup-button');
      if (!cod || !raiz.contains(cod)) return;
      if (!validar()) {
        evento.preventDefault();
        evento.stopImmediatePropagation();
      }
    }, true);

    var galeria = raiz.querySelector('[data-uc-galeria]');
    var pistaGaleria = raiz.querySelector('[data-uc-pista]');
    var escenario = raiz.querySelector('.uc-ficha__escenario');
    var cajaMiniaturas = raiz.querySelector('[data-uc-miniaturas]');
    var slides = lista(raiz.querySelectorAll('[data-uc-slide]'));
    var miniaturas = lista(raiz.querySelectorAll('[data-uc-miniatura]'));
    var flechaAnterior = raiz.querySelector('[data-uc-anterior]');
    var flechaSiguiente = raiz.querySelector('[data-uc-siguiente]');
    var indiceGaleria = 0;
    var alCambiarRecos = null;

    function verMiniatura(mini) {
      var caja = mini.parentNode;
      if (!caja) return;
      if (caja.scrollHeight > caja.clientHeight + 2) {
        if (mini.offsetTop < caja.scrollTop || mini.offsetTop + mini.offsetHeight > caja.scrollTop + caja.clientHeight) {
          caja.scrollTop = mini.offsetTop - 8;
        }
      }
      if (caja.scrollWidth > caja.clientWidth + 2) {
        if (mini.offsetLeft < caja.scrollLeft || mini.offsetLeft + mini.offsetWidth > caja.scrollLeft + caja.clientWidth) {
          caja.scrollLeft = mini.offsetLeft - 8;
        }
      }
    }

    function marcarGaleria(indice) {
      indiceGaleria = indice;
      miniaturas.forEach(function (mini, i) {
        mini.classList.toggle('uc-ficha__miniatura--activa', i === indice);
        if (i === indice) verMiniatura(mini);
      });
      if (flechaAnterior) flechaAnterior.disabled = indice <= 0;
      if (flechaSiguiente) flechaSiguiente.disabled = indice >= slides.length - 1;
    }

    function posicionarGaleria(desfase) {
      if (!pistaGaleria) return;
      if (!esEscritorio()) {
        pistaGaleria.style.transform = '';
        return;
      }
      pistaGaleria.style.transform = 'translateX(calc(' + (-indiceGaleria * 100) + '% + ' + (desfase || 0) + 'px))';
    }

    function irASlide(indice) {
      if (!galeria || !slides.length) return;
      indice = Math.max(0, Math.min(slides.length - 1, indice));
      marcarGaleria(indice);
      if (esEscritorio()) {
        posicionarGaleria(0);
      } else {
        galeria.scrollTo({ left: indice * galeria.clientWidth, behavior: 'smooth' });
      }
    }

    function irAMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(id)) {
          irASlide(i);
          return;
        }
      }
    }

    function ajustarMiniaturas() {
      if (!cajaMiniaturas || !escenario) return;
      if (esEscritorio() && escenario.offsetHeight > 0) {
        cajaMiniaturas.style.setProperty('max-height', escenario.offsetHeight + 'px', 'important');
      } else {
        cajaMiniaturas.style.removeProperty('max-height');
      }
    }

    if (galeria && slides.length > 1) {
      var reloj = null;
      galeria.addEventListener('scroll', function () {
        if (esEscritorio()) return;
        window.clearTimeout(reloj);
        reloj = window.setTimeout(function () {
          var ancho = galeria.clientWidth || 1;
          var indice = Math.round(galeria.scrollLeft / ancho);
          if (indice !== indiceGaleria) marcarGaleria(indice);
        }, 80);
      }, { passive: true });

      if (pistaGaleria) {
        arrastrar(galeria, pistaGaleria, {
          mover: function (d) {
            if ((indiceGaleria === 0 && d > 0) || (indiceGaleria === slides.length - 1 && d < 0)) d = d / 3;
            posicionarGaleria(d);
          },
          soltar: function (d) {
            var umbral = Math.min(80, galeria.clientWidth * 0.12);
            if (d < -umbral) {
              irASlide(indiceGaleria + 1);
            } else if (d > umbral) {
              irASlide(indiceGaleria - 1);
            } else {
              posicionarGaleria(0);
            }
          }
        });
      }
      marcarGaleria(0);
    }

    if (flechaAnterior) flechaAnterior.addEventListener('click', function () { irASlide(indiceGaleria - 1); });
    if (flechaSiguiente) flechaSiguiente.addEventListener('click', function () { irASlide(indiceGaleria + 1); });
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () { irASlide(parseInt(mini.getAttribute('data-indice'), 10)); });
    });

    function alCambiarVista() {
      ajustarMiniaturas();
      if (galeria) {
        if (esEscritorio()) {
          galeria.scrollLeft = 0;
        } else {
          galeria.scrollLeft = indiceGaleria * galeria.clientWidth;
        }
      }
      posicionarGaleria(0);
      if (alCambiarRecos) alCambiarRecos();
    }

    var consultaVista = window.matchMedia(ESCRITORIO);
    if (consultaVista.addEventListener) {
      consultaVista.addEventListener('change', alCambiarVista);
    } else if (consultaVista.addListener) {
      consultaVista.addListener(alCambiarVista);
    }

    if (escenario && 'ResizeObserver' in window) {
      new ResizeObserver(ajustarMiniaturas).observe(escenario);
    } else {
      window.addEventListener('resize', ajustarMiniaturas);
    }
    ajustarMiniaturas();

    var visor = raiz.querySelector('[data-uc-visor]');
    var visorImagen = raiz.querySelector('[data-uc-visor-imagen]');
    var grandes = galeria ? lista(galeria.querySelectorAll('img[data-grande]')) : [];
    var indiceVisor = 0;

    function bloquearScroll(bloquear) {
      document.documentElement.style.overflow = bloquear ? 'hidden' : '';
    }

    function mostrarVisor(indice) {
      if (!visor || !visorImagen || !grandes.length) return;
      if (indice < 0) indice = grandes.length - 1;
      if (indice >= grandes.length) indice = 0;
      indiceVisor = indice;
      visorImagen.src = grandes[indice].getAttribute('data-grande');
      visor.hidden = false;
      bloquearScroll(true);
    }

    function cerrarVisor() {
      if (!visor || visor.hidden) return;
      visor.hidden = true;
      bloquearScroll(false);
    }

    function indiceVisorActual() {
      var slide = slides[indiceGaleria];
      var img = slide ? slide.querySelector('img[data-grande]') : null;
      var posicion = img ? grandes.indexOf(img) : 0;
      return posicion < 0 ? 0 : posicion;
    }

    grandes.forEach(function (img, i) {
      img.addEventListener('click', function () { mostrarVisor(i); });
    });
    var ampliar = raiz.querySelector('[data-uc-ampliar]');
    if (ampliar) ampliar.addEventListener('click', function () { mostrarVisor(indiceVisorActual()); });
    if (visor) {
      lista(raiz.querySelectorAll('[data-uc-cerrar-visor]')).forEach(function (b) { b.addEventListener('click', cerrarVisor); });
      var visorAnterior = raiz.querySelector('[data-uc-visor-anterior]');
      var visorSiguiente = raiz.querySelector('[data-uc-visor-siguiente]');
      if (visorAnterior) visorAnterior.addEventListener('click', function () { mostrarVisor(indiceVisor - 1); });
      if (visorSiguiente) visorSiguiente.addEventListener('click', function () { mostrarVisor(indiceVisor + 1); });
      visor.addEventListener('click', function (e) { if (e.target === visor) cerrarVisor(); });
    }

    var pestanas = lista(raiz.querySelectorAll('[data-uc-pestana]'));
    var panelesTab = lista(raiz.querySelectorAll('[data-uc-panel-tab]'));
    pestanas.forEach(function (pestana) {
      pestana.addEventListener('click', function () {
        var nombre = pestana.getAttribute('data-uc-pestana');
        pestanas.forEach(function (p) { p.setAttribute('aria-selected', p === pestana ? 'true' : 'false'); });
        panelesTab.forEach(function (p) { p.hidden = p.getAttribute('data-uc-panel-tab') !== nombre; });
        medirRecorte();
      });
    });

    var modalGuia = raiz.querySelector('[data-uc-modal-guia]');
    var modalColores = raiz.querySelector('[data-uc-modal-colores]');

    function abrirModal(modal) {
      if (!modal) return;
      modal.hidden = false;
      bloquearScroll(true);
    }

    function cerrarModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      bloquearScroll(false);
    }

    lista(raiz.querySelectorAll('[data-uc-abrir-guia]')).forEach(function (b) {
      b.addEventListener('click', function () { abrirModal(modalGuia); });
    });
    lista(raiz.querySelectorAll('[data-uc-cerrar-guia]')).forEach(function (b) {
      b.addEventListener('click', function () { cerrarModal(modalGuia); });
    });
    lista(raiz.querySelectorAll('[data-uc-cerrar-colores]')).forEach(function (b) {
      b.addEventListener('click', function () { cerrarModal(modalColores); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      cerrarVisor();
      cerrarModal(modalGuia);
      cerrarModal(modalColores);
    });

    function normalizarTalla(texto) {
      return String(texto || '').toLowerCase().replace(/\([^)]*\)/g, '').replace(/usa?/g, '').replace(/\s+/g, '');
    }

    function grupoDeTalla(texto) {
      if (/\(\s*d\s*\)/i.test(texto)) return 'dama';
      if (/\(\s*h\s*\)/i.test(texto)) return 'caballero';
      return '';
    }

    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    raiz.querySelectorAll('[data-uc-guia]').forEach(function (guia) {
      var pestanas = Array.prototype.slice.call(guia.querySelectorAll('[data-uc-guia-pestana]'));
      var paneles = Array.prototype.slice.call(guia.querySelectorAll('[data-uc-guia-panel]'));
      var vistaTabla = guia.querySelector('[data-uc-guia-vista="tabla"]');
      var vistaMedir = guia.querySelector('[data-uc-guia-vista="medir"]');
      var escena = guia.querySelector('[data-uc-guia-escena]');
      var contador = guia.querySelector('[data-uc-guia-contador]');
      var campoCm = guia.querySelector('[data-uc-guia-cm]');
      var resultado = guia.querySelector('[data-uc-guia-resultado]');
      var verTabla = guia.querySelector('[data-uc-guia-ver]');
      var elegida = guia.querySelector('[data-uc-guia-elegida]');
      var medida = parseFloat(guia.getAttribute('data-medida')) || 26.5;
      var textoElegida = decodificar(guia.getAttribute('data-texto-elegida'));
      var textoTuTalla = decodificar(guia.getAttribute('data-texto-tu-talla'));
      var textoSube = decodificar(guia.getAttribute('data-texto-sube'));
      var textoFuera = decodificar(guia.getAttribute('data-texto-fuera'));
      var grupoActual = guia.getAttribute('data-inicial') || 'caballero';
      var relojes = [];
      var cuadro = null;

      function panelActual() {
        return guia.querySelector('[data-uc-guia-panel="' + grupoActual + '"]');
      }

      function nombreGrupo(grupo) {
        var boton = guia.querySelector('[data-uc-guia-pestana="' + grupo + '"]');
        return boton ? boton.textContent.trim() : grupo;
      }

      function elegirGrupo(grupo) {
        if (!guia.querySelector('[data-uc-guia-panel="' + grupo + '"]')) return;
        grupoActual = grupo;
        pestanas.forEach(function (p) {
          p.setAttribute('aria-selected', p.getAttribute('data-uc-guia-pestana') === grupo ? 'true' : 'false');
        });
        paneles.forEach(function (p) {
          p.hidden = p.getAttribute('data-uc-guia-panel') !== grupo;
        });
      }

      function quitarMarca(clase) {
        guia.querySelectorAll('.' + clase).forEach(function (f) { f.classList.remove(clase); });
      }

      function buscarFila(clave) {
        var encontrada = null;
        var orden = [grupoActual].concat(paneles.map(function (p) { return p.getAttribute('data-uc-guia-panel'); }));
        orden.some(function (grupo) {
          var panel = guia.querySelector('[data-uc-guia-panel="' + grupo + '"]');
          if (!panel) return false;
          var fila = Array.prototype.slice.call(panel.querySelectorAll('[data-uc-guia-fila]')).find(function (f) {
            return f.getAttribute('data-us') === clave;
          });
          if (fila) encontrada = { fila: fila, grupo: grupo };
          return !!fila;
        });
        return encontrada;
      }

      function sincronizar() {
        quitarMarca('uc-ficha-guia__fila--elegida');
        if (elegida) elegida.hidden = true;
        var marcado = raiz.querySelector('[data-uc-radio][data-indice="0"]:checked');
        if (!marcado) return;
        var grupo = grupoDeTalla(marcado.value);
        if (grupo) elegirGrupo(grupo);
        var resultadoBusqueda = buscarFila(normalizarTalla(marcado.value));
        if (!resultadoBusqueda) return;
        elegirGrupo(resultadoBusqueda.grupo);
        resultadoBusqueda.fila.classList.add('uc-ficha-guia__fila--elegida');
        if (elegida && textoElegida) {
          elegida.textContent = textoElegida.replace('{talla}', marcado.value);
          elegida.hidden = false;
        }
      }

      function detener() {
        relojes.forEach(function (r) { window.clearTimeout(r); });
        relojes = [];
        if (cuadro) window.cancelAnimationFrame(cuadro);
        cuadro = null;
        if (escena) escena.classList.remove('uc-ficha-guia--play');
        if (vistaMedir) vistaMedir.classList.remove('uc-ficha-guia--play-pasos');
        if (contador) contador.textContent = medida.toFixed(1);
      }

      function reproducir() {
        detener();
        if (!escena || sinMovimiento) return;
        void escena.offsetWidth;
        escena.classList.add('uc-ficha-guia--play');
        if (vistaMedir) vistaMedir.classList.add('uc-ficha-guia--play-pasos');
        if (contador) contador.textContent = '0.0';
        relojes.push(window.setTimeout(function () {
          var inicio = null;
          function paso(tiempo) {
            if (inicio === null) inicio = tiempo;
            var avance = Math.min(1, (tiempo - inicio) / 1200);
            var suave = 1 - Math.pow(1 - avance, 3);
            if (contador) contador.textContent = (medida * suave).toFixed(1);
            if (avance < 1) cuadro = window.requestAnimationFrame(paso);
          }
          cuadro = window.requestAnimationFrame(paso);
        }, 2300));
      }

      function subirAlInicio() {
        var caja = guia.closest('.uc-ficha__modal-caja');
        if (caja) caja.scrollTop = 0;
      }

      function mostrarVista(nombre) {
        if (vistaTabla) vistaTabla.hidden = nombre !== 'tabla';
        if (vistaMedir) vistaMedir.hidden = nombre !== 'medir';
        subirAlInicio();
        if (nombre === 'medir') {
          reproducir();
        } else {
          detener();
        }
      }

      function calcular() {
        if (!campoCm || !resultado) return;
        quitarMarca('uc-ficha-guia__fila--calculada');
        if (verTabla) verTabla.hidden = true;
        var valor = parseFloat(campoCm.value.replace(',', '.'));
        if (isNaN(valor) || valor <= 0) {
          resultado.hidden = true;
          return;
        }
        var panel = panelActual();
        if (!panel) return;
        var encabezados = Array.prototype.slice.call(panel.querySelectorAll('th')).map(function (th) { return th.textContent.trim(); });
        var filas = Array.prototype.slice.call(panel.querySelectorAll('[data-uc-guia-fila]')).filter(function (f) {
          return !isNaN(parseFloat(f.getAttribute('data-cm')));
        }).sort(function (a, b) {
          return parseFloat(a.getAttribute('data-cm')) - parseFloat(b.getAttribute('data-cm'));
        });
        var elegidaFila = filas.find(function (f) { return parseFloat(f.getAttribute('data-cm')) >= valor - 0.1; });
        var menor = filas.length ? parseFloat(filas[0].getAttribute('data-cm')) : 0;

        if (!elegidaFila || valor < menor - 1) {
          resultado.textContent = textoFuera;
          resultado.hidden = false;
          return;
        }

        var celdas = Array.prototype.slice.call(elegidaFila.querySelectorAll('td')).map(function (td) { return td.textContent.trim(); });
        var resumen = encabezados.map(function (titulo, i) { return titulo + ' ' + (celdas[i] || ''); }).join(' \u00b7 ');
        var texto = textoTuTalla.replace('{grupo}', nombreGrupo(grupoActual)) + ': ' + resumen;
        if (parseFloat(elegidaFila.getAttribute('data-cm')) > valor + 0.1 && textoSube) texto += '. ' + textoSube;
        resultado.textContent = texto;
        resultado.hidden = false;
        elegidaFila.classList.add('uc-ficha-guia__fila--calculada');
        if (verTabla) verTabla.hidden = false;
      }

      pestanas.forEach(function (p) {
        p.addEventListener('click', function () {
          elegirGrupo(p.getAttribute('data-uc-guia-pestana'));
          calcular();
        });
      });

      guia.querySelectorAll('[data-uc-guia-ir]').forEach(function (boton) {
        boton.addEventListener('click', function () { mostrarVista(boton.getAttribute('data-uc-guia-ir')); });
      });

      var repetir = guia.querySelector('[data-uc-guia-repetir]');
      if (repetir) repetir.addEventListener('click', reproducir);

      if (verTabla) verTabla.addEventListener('click', function () { mostrarVista('tabla'); });

      if (campoCm) {
        campoCm.addEventListener('input', calcular);
        campoCm.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') e.preventDefault();
        });
      }

      raiz.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-uc-radio]')) sincronizar();
      });

      raiz.querySelectorAll('[data-uc-abrir-guia]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!guia.closest('[data-uc-modal-guia]')) return;
          mostrarVista('tabla');
          sincronizar();
        });
      });

      raiz.querySelectorAll('[data-uc-cerrar-guia]').forEach(function (b) {
        b.addEventListener('click', detener);
      });

      elegirGrupo(grupoActual);
      sincronizar();
    });

    var agregarRecos = null;
    var depuracion = raiz.querySelector('[data-uc-debug]');
    var anotar = function (texto) {
      if (depuracion) depuracion.textContent += texto;
    };

    var cajaColores = raiz.querySelector('[data-uc-colores]');
    if (cajaColores) {
      var filaColores = cajaColores.querySelector('[data-uc-colores-fila]');
      var botonTodos = cajaColores.querySelector('[data-uc-abrir-colores]');
      var listaColores = modalColores ? modalColores.querySelector('[data-uc-colores-lista]') : null;
      var actual = cajaColores.getAttribute('data-actual') || '';
      var visibles = parseInt(cajaColores.getAttribute('data-visibles'), 10) || 5;
      var modo = cajaColores.getAttribute('data-modo');
      var busqueda = decodificar(cajaColores.getAttribute('data-modelo') || '').trim();
      var desdeTitulo = !busqueda;
      var maximo = 10;

      if (desdeTitulo) busqueda = modeloDelTitulo(raiz.getAttribute('data-titulo'));

      var mismoModelo = function (titulo) {
        var palabras = busqueda.toLowerCase().split(/\s+/).map(function (p) {
          return p.replace(/[^a-z0-9\u00e0-\u00ff]+/g, '');
        }).filter(function (p) { return p; });
        var texto = ' ' + String(titulo || '').toLowerCase().replace(/[^a-z0-9\u00e0-\u00ff]+/g, ' ') + ' ';
        return palabras.every(function (p) { return texto.indexOf(' ' + p + ' ') > -1; });
      };

      var pintarColores = function (otros) {
        otros = otros.filter(function (p) { return p && p.h && p.u && p.h !== actual; }).slice(0, maximo);
        if (!otros.length || !filaColores) return;
        var actualNodo = filaColores.querySelector('.uc-ficha__color--actual');
        var actualImg = actualNodo ? actualNodo.querySelector('img') : null;
        var actualDato = {
          t: actualNodo ? actualNodo.getAttribute('title') : '',
          u: actualNodo ? actualNodo.getAttribute('href') : '',
          i: actualImg ? actualImg.getAttribute('src') : '',
          h: actual
        };

        otros.slice(0, Math.max(0, visibles - 1)).forEach(function (p) {
          var enlace = document.createElement('a');
          enlace.className = 'uc-ficha__color';
          enlace.href = p.u;
          enlace.title = p.t;
          if (p.i) {
            var img = document.createElement('img');
            img.src = conAncho(p.i, 200);
            img.alt = p.t;
            img.loading = 'lazy';
            img.width = 72;
            img.height = 54;
            enlace.appendChild(img);
          }
          filaColores.appendChild(enlace);
        });

        var todos = [actualDato].concat(otros);
        if (botonTodos && todos.length > visibles) botonTodos.hidden = false;

        if (listaColores) {
          var check = '<span class="uc-ficha__colores-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';
          listaColores.innerHTML = todos.map(function (p) {
            var esActual = p.h === actual;
            return '<li><a class="uc-ficha__colores-opcion' + (esActual ? ' uc-ficha__colores-opcion--actual' : '') + '" href="' + escapar(p.u) + '"' + (esActual ? ' aria-current="page"' : '') + '>' +
              '<span class="uc-ficha__colores-miniatura">' + (p.i ? '<img src="' + escapar(conAncho(p.i, 200)) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="uc-ficha__colores-nombre">' + escapar(p.t) + '</span>' +
              (esActual ? check : '') +
            '</a></li>';
          }).join('');
        }
        cajaColores.hidden = false;
      };

      var base = modo === 'productos' ? leerJSON(cajaColores.querySelector('[data-uc-colores-datos]')) : [];
      var debeBuscar = !!(window.fetch && busqueda && base.length < maximo && !(desdeTitulo && busqueda.split(/\s+/).length < 2));

      if (!debeBuscar) {
        pintarColores(base);
        anotar(desdeTitulo ? ' \u00b7 sin modelo en el titulo' : '');
      } else {
        var presentes = base.map(function (p) { return p.h; }).concat([actual]);
        var rutaPredictiva = raiz.getAttribute('data-ruta-predictiva') || '/search/suggest';
        var urlBusqueda = rutaPredictiva + '.json?q=' + encodeURIComponent(busqueda) +
          '&resources[type]=product&resources[limit]=10' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title';
        fetch(urlBusqueda, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (respuesta) {
            var productos = (respuesta && respuesta.resources && respuesta.resources.results && respuesta.resources.results.products) || [];
            var nuevos = productos.filter(function (p) {
              return p && p.handle && presentes.indexOf(p.handle) < 0 && mismoModelo(p.title);
            }).map(function (p) {
              var imagen = p.featured_image && typeof p.featured_image === 'object' ? p.featured_image.url : p.image;
              return {
                t: p.title,
                u: p.url,
                h: p.handle,
                i: imagen || '',
                precio: Math.round(parseFloat(p.price || p.price_min || 0) * 100),
                antes: Math.round(parseFloat(p.compare_at_price_max || 0) * 100)
              };
            });
            pintarColores(base.concat(nuevos));
            if (agregarRecos && nuevos.length) agregarRecos(nuevos, true);
            anotar(' \u00b7 buscando "' + busqueda + '": ' + productos.length + ' resultados, ' + nuevos.length + ' del mismo modelo');
          })
          .catch(function () {
            pintarColores(base);
            anotar(' \u00b7 la busqueda fallo');
          });
      }

      if (botonTodos) botonTodos.addEventListener('click', function () { abrirModal(modalColores); });
    }

    function modeloDelTitulo(titulo) {
      var texto = String(titulo || '');
      var corte = texto.search(/["\u201c\u201d\u00ab]| - | \u2013 | \u2014 |\(/);
      if (corte < 1) return '';
      return texto.slice(0, corte).trim();
    }

    var recos = raiz.querySelector('[data-uc-recos]');
    if (recos) {
      var ventana = recos.querySelector('[data-uc-recos-ventana]');
      var pistaRecos = recos.querySelector('[data-uc-recos-pista]');
      var recosAnterior = recos.querySelector('[data-uc-recos-anterior]');
      var recosSiguiente = recos.querySelector('[data-uc-recos-siguiente]');
      var desplazamiento = 0;

      var pasoRecos = function () {
        var t = pistaRecos ? pistaRecos.children : [];
        if (t.length > 1) return t[1].offsetLeft - t[0].offsetLeft;
        return ventana ? ventana.clientWidth : 1;
      };

      var maximoRecos = function () {
        if (!pistaRecos || !ventana) return 0;
        return Math.max(0, pistaRecos.scrollWidth - ventana.clientWidth);
      };

      var aplicarRecos = function (desfase) {
        if (!pistaRecos || !ventana) return;
        if (!esEscritorio()) {
          pistaRecos.style.transform = '';
          return;
        }
        var maximoActual = maximoRecos();
        desplazamiento = Math.max(0, Math.min(maximoActual, desplazamiento));
        pistaRecos.style.transform = 'translateX(' + (-(desplazamiento - (desfase || 0))) + 'px)';
        if (recosAnterior) recosAnterior.disabled = desplazamiento <= 1;
        if (recosSiguiente) recosSiguiente.disabled = desplazamiento >= maximoActual - 1;
      };

      var moverRecos = function (direccion) {
        if (!ventana) return;
        if (esEscritorio()) {
          var paso = pasoRecos() || 1;
          var visibles = Math.max(1, Math.floor((ventana.clientWidth + 4) / paso));
          desplazamiento += direccion * visibles * paso;
          aplicarRecos(0);
        } else {
          ventana.scrollBy({ left: direccion * ventana.clientWidth * 0.8, behavior: 'smooth' });
        }
      };

      if (recosAnterior) recosAnterior.addEventListener('click', function () { moverRecos(-1); });
      if (recosSiguiente) recosSiguiente.addEventListener('click', function () { moverRecos(1); });

      if (ventana && pistaRecos) {
        arrastrar(ventana, pistaRecos, {
          mover: function (d) {
            var maximoActual = maximoRecos();
            var destino = desplazamiento - d;
            if (destino < 0) d = desplazamiento - destino / 3;
            if (destino > maximoActual) d = desplazamiento - maximoActual - (destino - maximoActual) / 3;
            aplicarRecos(d);
          },
          soltar: function (d) {
            var paso = pasoRecos() || 1;
            desplazamiento = Math.round((desplazamiento - d) / paso) * paso;
            aplicarRecos(0);
          }
        });
      }

      alCambiarRecos = function () {
        if (ventana) ventana.scrollLeft = 0;
        desplazamiento = 0;
        aplicarRecos(0);
      };
      window.addEventListener('resize', function () { aplicarRecos(0); });

      var formatear = function (centavos) {
        var formato = raiz.getAttribute('data-formato') || '';
        if (formato.indexOf('amount') < 0) formato = '$[amount_no_decimals_with_comma_separator]';
        var tipos = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_apostrophe_separator: [2, '\'', '.'],
          amount_with_period_and_space_separator: [2, ' ', '.']
        };
        return formato.replace(/(?:\{\{|\[)\s*(\w+)\s*(?:\}\}|\])/, function (todo, clave) {
          var t = tipos[clave] || tipos.amount;
          var partes = (Number(centavos || 0) / 100).toFixed(t[0]).split('.');
          var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, t[1]);
          return partes[1] ? entero + t[2] + partes[1] : entero;
        });
      };

      var tarjeta = function (p, origen) {
        var antes = p.antes && p.antes > p.precio ? ' <s>' + escapar(formatear(p.antes)) + '</s>' : '';
        return '<a class="uc-ficha__reco" href="' + escapar(p.u) + '" data-handle="' + escapar(p.h) + '" data-origen="' + origen + '" draggable="false">' +
          '<span class="uc-ficha__reco-imagen">' + (p.i ? '<img src="' + escapar(conAncho(p.i, 400)) + '" alt="' + escapar(p.t) + '" loading="lazy" width="400" height="400" draggable="false">' : '') + '</span>' +
          '<span class="uc-ficha__reco-titulo">' + escapar(p.t) + '</span>' +
          '<span class="uc-ficha__reco-precio">' + escapar(formatear(p.precio)) + antes + '</span>' +
        '</a>';
      };

      agregarRecos = function (productos, delModelo) {
        if (!pistaRecos) return;
        var presentes = lista(pistaRecos.querySelectorAll('[data-handle]')).map(function (a) { return a.getAttribute('data-handle'); });
        presentes.push(raiz.getAttribute('data-handle'));
        productos = productos.filter(function (p) { return p && p.h && p.u && presentes.indexOf(p.h) < 0; });
        if (!productos.length) return;
        var html = productos.map(function (p) { return tarjeta(p, delModelo ? 'modelo' : 'shopify'); }).join('');
        var primeraShopify = pistaRecos.querySelector('[data-origen="shopify"]');
        if (delModelo && primeraShopify) {
          primeraShopify.insertAdjacentHTML('beforebegin', html);
        } else {
          pistaRecos.insertAdjacentHTML('beforeend', html);
        }
        var sobrantes = lista(pistaRecos.children).slice(10);
        sobrantes.forEach(function (n) { n.parentNode.removeChild(n); });
        recos.hidden = false;
        aplicarRecos(0);
      };

      var completarRecos = function (productos) {
        agregarRecos(productos.map(function (p) {
          var imagen = p.featured_image && typeof p.featured_image === 'object' ? (p.featured_image.url || p.featured_image.src) : p.featured_image;
          return { t: p.title, u: p.url, h: p.handle, i: imagen || '', precio: p.price, antes: p.compare_at_price };
        }), false);
      };

      var cargado = false;
      var cargarRecos = function () {
        if (cargado || !window.fetch) return;
        cargado = true;
        var ruta = raiz.getAttribute('data-ruta-recomendados') || '/recommendations/products';
        var limite = parseInt(raiz.getAttribute('data-recomendados'), 10) || 10;
        fetch(ruta + '.json?product_id=' + raiz.getAttribute('data-producto-id') + '&limit=' + limite + '&intent=related')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (datos) { completarRecos((datos && datos.products) || []); })
          .catch(function () {});
      };

      if (recos.getAttribute('data-completar') === 'true') {
        if ('IntersectionObserver' in window) {
          var observador = new IntersectionObserver(function (entradas) {
            if (entradas.some(function (e) { return e.isIntersecting; })) {
              observador.disconnect();
              cargarRecos();
            }
          }, { rootMargin: '600px 0px' });
          observador.observe(recos.parentNode || recos);
        } else {
          cargarRecos();
        }
      }
      aplicarRecos(0);
    }

    var recorte = raiz.querySelector('[data-uc-recorte]');
    var verMas = raiz.querySelector('[data-uc-ver-mas]');
    var medirRecorte = function () {};
    if (recorte && verMas) {
      var textoVerMas = verMas.querySelector('[data-uc-ver-mas-texto]');
      var textoMas = textoVerMas ? textoVerMas.textContent : '';
      var textoMenos = decodificar(verMas.getAttribute('data-texto-menos')) || textoMas;
      medirRecorte = function () {
        if (!recorte.offsetParent || recorte.classList.contains('uc-ficha__recorte--abierto')) return;
        recorte.classList.remove('uc-ficha__recorte--corto');
        var sobra = recorte.scrollHeight > recorte.clientHeight + 8;
        recorte.classList.toggle('uc-ficha__recorte--corto', !sobra);
        verMas.hidden = !sobra;
      };
      verMas.addEventListener('click', function () {
        var abierto = recorte.classList.toggle('uc-ficha__recorte--abierto');
        verMas.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        if (textoVerMas) textoVerMas.textContent = abierto ? textoMenos : textoMas;
        if (!abierto && recorte.getBoundingClientRect().top < 0) {
          recorte.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      medirRecorte();
      window.addEventListener('resize', medirRecorte);
      window.addEventListener('load', medirRecorte);
    }

    var handleActual = raiz.getAttribute('data-handle');
    if (handleActual) {
      try {
        var vistos = JSON.parse(window.localStorage.getItem(CLAVE_VISTOS) || '[]');
        vistos = vistos.filter(function (h) { return h !== handleActual; });
        vistos.unshift(handleActual);
        window.localStorage.setItem(CLAVE_VISTOS, JSON.stringify(vistos.slice(0, 20)));
      } catch (e) {}
    }

    actualizar(false);
  }

  function iniciarTodas(contexto) {
    lista((contexto || document).querySelectorAll('[data-uc-ficha]')).forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodas(); });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

(function () {
  function lista(nodos) {
    return Array.prototype.slice.call(nodos || []);
  }

  function iniciarSocial(raiz) {
    if (raiz.dataset.ucSocialInit === 'true') { return; }
    raiz.dataset.ucSocialInit = 'true';

    var pista = raiz.querySelector('[data-uc-social-pista]');
    var items = lista(raiz.querySelectorAll('[data-uc-social-item]'));
    var puntos = lista(raiz.querySelectorAll('[data-uc-social-punto]'));
    var visor = raiz.querySelector('[data-uc-social-visor]');
    var imagen = raiz.querySelector('[data-uc-social-imagen]');
    var texto = raiz.querySelector('[data-uc-social-texto]');
    var nombre = raiz.querySelector('[data-uc-social-nombre]');
    var estrellas = raiz.querySelector('[data-uc-social-estrellas]');
    if (!items.length) { return; }

    function abrir(item) {
      if (!visor) { return; }
      var grande = item.getAttribute('data-grande') || '';
      var img = item.querySelector('img');
      if (imagen) {
        imagen.setAttribute('src', grande || (img ? img.getAttribute('src') : ''));
        imagen.setAttribute('alt', item.getAttribute('data-nombre') || '');
      }
      if (texto) { texto.textContent = item.getAttribute('data-texto') || ''; }
      if (nombre) {
        var quien = item.getAttribute('data-nombre') || '';
        var donde = item.getAttribute('data-ciudad') || '';
        nombre.textContent = donde ? (quien + ' ' + String.fromCharCode(183) + ' ' + donde) : quien;
      }
      if (estrellas) {
        var n = parseInt(item.getAttribute('data-estrellas'), 10) || 0;
        var txt = '';
        for (var i = 0; i < n; i++) { txt += String.fromCharCode(9733); }
        estrellas.textContent = txt;
      }
      visor.removeAttribute('hidden');
      document.documentElement.style.setProperty('overflow', 'hidden');
    }

    function cerrar() {
      if (!visor) { return; }
      visor.setAttribute('hidden', 'hidden');
      document.documentElement.style.removeProperty('overflow');
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () { abrir(item); });
    });

    lista(raiz.querySelectorAll('[data-uc-social-cerrar]')).forEach(function (b) {
      b.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && visor && !visor.hasAttribute('hidden')) { cerrar(); }
    });

    if (pista && puntos.length) {
      var pendiente = false;
      pista.addEventListener('scroll', function () {
        if (pendiente) { return; }
        pendiente = true;
        window.requestAnimationFrame(function () {
          pendiente = false;
          var centro = pista.scrollLeft + pista.clientWidth / 2;
          var mejor = 0;
          var dif = Infinity;
          items.forEach(function (it, i) {
            var medio = it.offsetLeft - pista.offsetLeft + it.offsetWidth / 2;
            var d = Math.abs(medio - centro);
            if (d < dif) { dif = d; mejor = i; }
          });
          puntos.forEach(function (p, i) { p.classList.toggle('esta-activo', i === mejor); });
        });
      }, { passive: true });

      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () {
          if (!items[i] || !pista) { return; }
          pista.scrollTo({ left: items[i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
        });
      });
    }
  }

  function todasSocial(contexto) {
    lista((contexto || document).querySelectorAll('[data-uc-social]')).forEach(iniciarSocial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { todasSocial(); });
  } else {
    todasSocial();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    todasSocial(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultimos-drops-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.ucIngresosIniciado) { return; }
  window.ucIngresosIniciado = true;

  function iniciar(seccion) {
    if (seccion.dataset.uciInit === 'true') { return; }
    seccion.dataset.uciInit = 'true';

    var rejilla = seccion.querySelector('[data-rejilla]');
    if (!rejilla) { return; }

    var tarjetas = Array.prototype.slice.call(rejilla.querySelectorAll('[data-tarjeta]'));
    var chips = Array.prototype.slice.call(seccion.querySelectorAll('[data-chip]'));
    var btnMas = seccion.querySelector('[data-ver-mas]');
    var sinRes = seccion.querySelector('[data-sin]');

    var porPagina = parseInt(seccion.getAttribute('data-por-pagina'), 10) || 6;
    var visibles = porPagina;
    var grupoActual = '';

    function coincide(t) {
      if (!grupoActual) { return true; }
      return (t.getAttribute('data-grupos') || '').indexOf('||' + grupoActual + '||') !== -1;
    }

    function pintar() {
      var cuenta = 0;
      tarjetas.forEach(function (t) {
        if (coincide(t)) {
          cuenta++;
          if (cuenta <= visibles) { t.removeAttribute('hidden'); } else { t.setAttribute('hidden', 'hidden'); }
        } else {
          t.setAttribute('hidden', 'hidden');
        }
      });
      if (sinRes) {
        if (cuenta === 0) { sinRes.removeAttribute('hidden'); } else { sinRes.setAttribute('hidden', 'hidden'); }
      }
      if (btnMas) {
        if (cuenta > visibles) { btnMas.removeAttribute('hidden'); } else { btnMas.setAttribute('hidden', 'hidden'); }
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.remove('esta-activo'); });
        c.classList.add('esta-activo');
        grupoActual = (c.getAttribute('data-grupo') || '').toLowerCase().trim();
        visibles = porPagina;
        pintar();
      });
    });

    if (btnMas) {
      btnMas.addEventListener('click', function () { visibles += porPagina; pintar(); });
    }

    var anchoPC = window.matchMedia('(min-width: 990px)');

    tarjetas.forEach(function (tarjeta) {
      var galeria = tarjeta.querySelector('[data-galeria]');
      if (!galeria) { return; }
      var media = tarjeta.querySelector('.uci-media');
      var slides = Array.prototype.slice.call(galeria.querySelectorAll('[data-slide]'));
      var puntos = Array.prototype.slice.call(tarjeta.querySelectorAll('[data-punto]'));
      if (slides.length < 2) { return; }

      var indice = 0;
      var brillo = null;

      function marcar(idx) {
        indice = idx;
        puntos.forEach(function (p) {
          p.classList.toggle('esta-activo', p.getAttribute('data-indice') === String(idx));
        });
      }

      function mostrar(idx, conBrillo) {
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        if (anchoPC.matches) {
          if (idx === indice && slides[idx].classList.contains('esta-activa')) { marcar(idx); return; }
          slides.forEach(function (s, i) { s.classList.toggle('esta-activa', i === idx); });
          if (conBrillo && media) {
            media.classList.remove('esta-brillando');
            void media.offsetWidth;
            media.classList.add('esta-brillando');
            if (brillo) { clearTimeout(brillo); }
            brillo = setTimeout(function () { media.classList.remove('esta-brillando'); }, 900);
          }
        } else {
          var destino = slides[idx];
          if (destino) { galeria.scrollTo({ left: destino.offsetLeft - galeria.offsetLeft, behavior: 'smooth' }); }
        }
        marcar(idx);
      }

      var pendiente = false;
      galeria.addEventListener('scroll', function () {
        if (anchoPC.matches || pendiente) { return; }
        pendiente = true;
        window.requestAnimationFrame(function () {
          pendiente = false;
          marcar(Math.round(galeria.scrollLeft / Math.max(1, galeria.clientWidth)));
        });
      }, { passive: true });

      puntos.forEach(function (p) {
        p.addEventListener('click', function (e) {
          e.preventDefault();
          mostrar(parseInt(p.getAttribute('data-indice'), 10) || 0, true);
        });
      });

      tarjeta.querySelectorAll('[data-flecha]').forEach(function (f) {
        f.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          mostrar(indice + (parseInt(f.getAttribute('data-flecha'), 10) || 1), true);
        });
      });

      if (media) {
        var ultimo = -1;
        media.addEventListener('mouseenter', function () {
          if (!anchoPC.matches) { return; }
          ultimo = 1;
          mostrar(1, true);
        });
        media.addEventListener('mousemove', function (e) {
          if (!anchoPC.matches || slides.length < 3) { return; }
          var r = media.getBoundingClientRect();
          if (!r.width) { return; }
          var prop = (e.clientX - r.left) / r.width;
          prop = Math.max(0, Math.min(0.999, prop));
          var idx = 1 + Math.floor(prop * (slides.length - 1));
          if (idx !== ultimo) { ultimo = idx; mostrar(idx, true); }
        });
        media.addEventListener('mouseleave', function () {
          if (!anchoPC.matches) { return; }
          ultimo = -1;
          mostrar(0, true);
        });
      }

      var x0 = 0, y0 = 0, movido = false;
      galeria.addEventListener('touchstart', function (e) {
        if (!e.touches.length) { return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; movido = false;
      }, { passive: true });
      galeria.addEventListener('touchmove', function (e) {
        if (!e.touches.length) { return; }
        if (Math.abs(e.touches[0].clientX - x0) > 9 || Math.abs(e.touches[0].clientY - y0) > 9) { movido = true; }
      }, { passive: true });
      slides.forEach(function (s) {
        s.addEventListener('click', function (e) {
          if (movido) { e.preventDefault(); movido = false; }
        });
      });

      function reajustar() {
        if (anchoPC.matches) {
          slides.forEach(function (s, i) { s.classList.toggle('esta-activa', i === indice); });
        } else {
          galeria.scrollLeft = indice * galeria.clientWidth;
        }
      }
      if (anchoPC.addEventListener) { anchoPC.addEventListener('change', reajustar); }
    });

    pintar();
  }

  function todo() { document.querySelectorAll('[data-uci]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();
})();
